import _createClass from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/* eslint-disable no-unused-vars */
/** Class representing a Metric */
var Metric = /*#__PURE__*/_createClass(
/**
 * Create a Metric
 *
 * A Metric is a Name and a Value. A Metric is a base unit in Helix.
 * @property {string} name
 * @property {string} value
 */
function Metric() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, Metric);
  /** @type {string} */
  this.name = name;
  /** @type {string} */
  this.value = value;
});
/** Class representing a DateRange */
var DateRange = /*#__PURE__*/_createClass(
/**
 * Create a DateRange
 *
 * A DateRange is a specific time period designated by both a start and end date and time.
 * @property {Date} startDate
 * @property {Date} endDate
 */
function DateRange() {
  var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  _classCallCheck(this, DateRange);
  /** @type {Date} */
  this.startDate = startDate;
  /** @type {Date} */
  this.endDate = endDate;
});
/** Class representing a MetricDefinition */
var MetricDefinition = /*#__PURE__*/_createClass(
/**
 * Create a MetricDefinition
 *
 * A MetricDefinition is the set of data to be used as instructions for assembling a custom metric.
 * @property {string} name
 * @property {string[]} metricNames
 * @property {string} expression
 */
function MetricDefinition() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var expression = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  _classCallCheck(this, MetricDefinition);
  /** @type {string} */
  this.name = name;
  /** @type {string[]} */
  this.metricNames = metricNames;
  /** @type {string} */
  this.expression = expression;
});
/** Class representing a Operation */
var Operation = /*#__PURE__*/_createClass(
/**
 * Create a Operation
 *
 * An Operation is a specific task performed inside the Helix Platform.
 * @property {string} name
 * @property {string} type
 * @property {string} target
 * @property {string} operator
 * @property {string} value
 */
function Operation() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var operator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  _classCallCheck(this, Operation);
  /** @type {string} */
  this.name = name;
  /** @type {string} */
  this.type = type;
  /** @type {string} */
  this.target = target;
  /** @type {string} */
  this.operator = operator;
  /** @type {string} */
  this.value = value;
});
/* eslint-disable no-unused-vars */
/** Class representing a User */
var User = /*#__PURE__*/_createClass(
/**
 * Create a User
 *
 * A User is any identified entity that uses of the Helix platform.
 *
 * @property {UserDescription} userDescription
 * @property {UserMetric[]} userMetrics
 */
function User() {
  var userDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserDescription();
  var userMetrics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  _classCallCheck(this, User);
  /** @type {UserDescription} */
  this.userDescription = userDescription;
  /** @type {UserMetric[]} */
  this.userMetrics = userMetrics;
});
/** Class representing a UserDescription */
var UserDescription = /*#__PURE__*/_createClass(
/**
 * Create a UserDescription
 *
 * A UserDescription is the set of details used to describe a User.
 *
 * @property {String} employeeId
 * @property {String} location
 * @property {String} client
 * @property {String} payProgram
 */
function UserDescription() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var client = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var payProgram = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  _classCallCheck(this, UserDescription);
  /** @type {String} */
  this.employeeId = employeeId;
  /** @type {String} */
  this.location = location;
  /** @type {String} */
  this.client = client;
  /** @type {String} */
  this.payProgram = payProgram;
});
/** Class representing a UserMetric */
var UserMetric = /*#__PURE__*/_createClass(
/**
 * Create a UserMetric
 *
 * A UserMetric is the relationship of a Metric to a specific User by Asurion's EmployeeId.
 *
 * @property {String} employeeId
 * @property {Metric} metric
 */
function UserMetric() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Metric();
  _classCallCheck(this, UserMetric);
  /** @type {String} */
  this.employeeId = employeeId;
  /** @type {Metric} */
  this.metric = metric;
});
/** Class representing an ExpertAssociation */
var ExpertAssociation = /*#__PURE__*/_createClass(
/**
 * Create an ExpertAssociation
 *
 * An ExpertAssociation is the data shape that results from a custom query
 * to EDP's Hierarchy table joined to PerformancePortal's Primary Client table.
 *
 * @property {String} expertId
 * @property {String} location
 * @property {String} clientName
 * @property {String} jobCode
 */
function ExpertAssociation() {
  var expertId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var clientName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var jobCode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  _classCallCheck(this, ExpertAssociation);
  /** @type {String} */
  this.expertId = expertId;
  /** @type {String} */
  this.location = location;
  /** @type {String} */
  this.clientName = clientName;
  /** @type {String} */
  this.jobCode = jobCode;
});
/** Class representing a UserRow */
var UserRow = /*#__PURE__*/_createClass(
/**
 * Create a UserRow
 *
 * A UserRow is the data shape that is stored in the Helix HelixUser's Table.
 *
 * @property {String} hashKey
 * @property {UserDescription} userDescription
 * @property {UserMetric[]} userMetrics
 */
function UserRow() {
  var hashKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var userDescription = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new UserDescription();
  var userMetrics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  _classCallCheck(this, UserRow);
  /** @type {String} */
  this.hashKey = hashKey;
  /** @type {UserDescription} */
  this.userDescription = userDescription;
  /** @type {UserMetric[]} */
  this.userMetrics = userMetrics;
});
/** Class representing an ExpertAssociationRow */
var ExpertAssociationRow = /*#__PURE__*/_createClass(
/**
 * Create an ExpertAssociationRow
 *
 * An ExpertAssociationRow is the data shape that results from a custom query
 * to EDP's Hierarchy table joined to PerformancePortal's Primary Client table.
 *
 * @property {String} expert_id
 * @property {String} location
 * @property {String} client_name
 * @property {String} jobcode
 */
function ExpertAssociationRow() {
  var expert_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var client_name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var jobcode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  _classCallCheck(this, ExpertAssociationRow);
  /** @type {String} */
  this.expert_id = expert_id;
  /** @type {String} */
  this.location = location;
  /** @type {String} */
  this.client_name = client_name;
  /** @type {String} */
  this.jobcode = jobcode;
});
/* eslint-disable no-unused-vars */
/**
 * @function userToUserDescription
 * User -> UserDescription
 * @param {User} user
 * @returns {UserDescription}
 */
var userToUserDescription = function userToUserDescription() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new User(),
    userDescription = _ref.userDescription;
  return userDescription;
};

/**
 * @function userToUserMetrics
 * User -> [UserMetric]
 * @param {User} user
 * @returns {UserMetric[]}
 */
var userToUserMetrics = function userToUserMetrics() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new User(),
    userMetrics = _ref2.userMetrics;
  return userMetrics;
};

/**
 * @function userDescriptionToEmployeeId
 * UserDescription -> String
 * @param {UserDescription} userDescription
 * @returns {String}
 */
var userDescriptionToEmployeeId = function userDescriptionToEmployeeId() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserDescription(),
    employeeId = _ref3.employeeId;
  return employeeId;
};

/**
 * @function userDescriptionToLocation
 * UserDescription -> String
 * @param {UserDescription} userDescription
 * @returns {String}
 */
var userDescriptionToLocation = function userDescriptionToLocation() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserDescription(),
    location = _ref4.location;
  return location;
};

/**
 * @function userDescriptionToClient
 * UserDescription -> String
 * @param {UserDescription} userDescription
 * @returns {String}
 */
var userDescriptionToClient = function userDescriptionToClient() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserDescription(),
    client = _ref5.client;
  return client;
};

/**
 * @function userDescriptionToPayProgram
 * UserDescription -> String
 * @param {UserDescription} userDescription
 * @returns {String}
 */
var userDescriptionToPayProgram = function userDescriptionToPayProgram() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserDescription(),
    payProgram = _ref6.payProgram;
  return payProgram;
};

/**
 * @function userMetricToEmployeeId
 * UserMetric -> String
 * @param {UserMetric} userMetric
 * @returns {String}
 */
var userMetricToEmployeeId = function userMetricToEmployeeId() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserMetric(),
    employeeId = _ref7.employeeId;
  return employeeId;
};

/**
 * @function userMetricToMetric
 * UserMetric -> Metric
 * @param {UserMetric} userMetric
 * @returns {Metric}
 */
var userMetricToMetric = function userMetricToMetric() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserMetric(),
    metric = _ref8.metric;
  return metric;
};

/**
 * @function userRowToHashKey
 * UserRow -> String
 * @param {UserRow} userRow
 * @returns {String}
 */
var userRowToHashKey = function userRowToHashKey() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserRow(),
    hashKey = _ref9.hashKey;
  return hashKey;
};

/**
 * @function userRowToUserDescription
 * UserRow -> UserDescription
 * @param {UserRow} userRow
 * @returns {UserDescription}
 */
var userRowToUserDescription = function userRowToUserDescription() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserRow(),
    userDescription = _ref10.userDescription;
  return userDescription;
};

/**
 * @function userRowToUserMetrics
 * UserRow -> [UserMetric]
 * @param {UserRow} userRow
 * @returns {UserMetric[]}
 */
var userRowToUserMetrics = function userRowToUserMetrics() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserRow(),
    userMetrics = _ref11.userMetrics;
  return userMetrics;
};

/**
 * @function expertAssociationToExpertId
 * ExpertAssociation -> String
 * @param {ExpertAssociation} expertAssociation
 * @returns {String}
 */
var expertAssociationToExpertId = function expertAssociationToExpertId() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociation(),
    expertId = _ref12.expertId;
  return expertId;
};

/**
 * @function expertAssociationToLocation
 * ExpertAssociation -> String
 * @param {ExpertAssociation} expertAssociation
 * @returns {String}
 */
var expertAssociationToLocation = function expertAssociationToLocation() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociation(),
    location = _ref13.location;
  return location;
};

/**
 * @function expertAssociationToClientName
 * ExpertAssociation -> String
 * @param {ExpertAssociation} expertAssociation
 * @returns {String}
 */
var expertAssociationToClientName = function expertAssociationToClientName() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociation(),
    clientName = _ref14.clientName;
  return clientName;
};

/**
 * @function expertAssociationToJobCode
 * ExpertAssociation -> String
 * @param {ExpertAssociation} expertAssociation
 * @returns {String}
 */
var expertAssociationToJobCode = function expertAssociationToJobCode() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociation(),
    jobCode = _ref15.jobCode;
  return jobCode;
};

/**
 * @function expertAssociationRowToExpert_Id
 * ExpertAssociationRow -> String
 * @param {ExpertAssociationRow} expertAssociationRow
 * @returns {String}
 */
var expertAssociationRowToExpert_Id = function expertAssociationRowToExpert_Id() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociationRow(),
    expert_id = _ref16.expert_id;
  return expert_id;
};

/**
 * @function expertAssociationRowToClient_Name
 * ExpertAssociationRow -> String
 * @param {ExpertAssociationRow} expertAssociationRow
 * @returns {String}
 */
var expertAssociationRowToClient_Name = function expertAssociationRowToClient_Name() {
  var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociationRow(),
    client_name = _ref17.client_name;
  return client_name;
};

/**
 * @function expertAssociationRowToJobcode
 * ExpertAssociationRow -> String
 * @param {ExpertAssociationRow} expertAssociationRow
 * @returns {String}
 */
var expertAssociationRowToJobcode = function expertAssociationRowToJobcode() {
  var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociationRow(),
    jobcode = _ref18.jobcode;
  return jobcode;
};

/**
 * @function expertAssociationRowToLocation
 * ExpertAssociationRow -> String
 * @param {ExpertAssociationRow} expertAssociationRow
 * @returns {String}
 */
var expertAssociationRowToLocation = function expertAssociationRowToLocation() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new ExpertAssociationRow(),
    location = _ref19.location;
  return location;
};

/* eslint-disable no-unused-vars */

/**
 * Get startDate from DateRange
 *
 * dateRangeToStartDate :: DateRange -> Date
 * @function dateRangeToStartDate
 * @param {DateRange} dateRange
 * @returns {Date}
 */
var dateRangeToStartDate = function dateRangeToStartDate() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DateRange(),
    startDate = _ref20.startDate;
  return startDate;
};

/**
 * Get endDate from DateRange
 *
 * dateRangeToStartDate :: DateRange -> Date
 * @function dateRangeToEndDate
 * @param {DateRange} dateRange
 * @returns {Date}
 */
var dateRangeToEndDate = function dateRangeToEndDate() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DateRange(),
    endDate = _ref21.endDate;
  return endDate;
};

/**
 * Get name from Metric
 *
 * metricToName :: Metric -> String
 * @function metricToName
 * @param {Metric} metric
 * @returns {String}
 */
var metricToName = function metricToName() {
  var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Metric(),
    name = _ref22.name;
  return name;
};

/**
 * Get value from Metric
 *
 * metricToValue :: Metric -> String
 * @function metricToValue
 * @param {Metric} metric
 * @returns {String}
 */
var metricToValue = function metricToValue() {
  var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Metric(),
    value = _ref23.value;
  return value;
};

/**
 * Get name from MetricDefinition
 *
 * metricDefinitionToName :: MetricDefinition -> String
 * @function metricDefinitionToName
 * @param {MetricDefinition} metricDefinition
 * @returns {String}
 */
var metricDefinitionToName = function metricDefinitionToName() {
  var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricDefinition(),
    name = _ref24.name;
  return name;
};

/**
 * Get metricNames from MetricDefinition
 *
 * metricDefinitionToMetricNames :: MetricDefinition -> [String]
 * @function metricDefinitionToMetricNames
 * @param {MetricDefinition} metricDefinition
 * @returns {String[]}
 */
var metricDefinitionToMetricNames = function metricDefinitionToMetricNames() {
  var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricDefinition(),
    metricNames = _ref25.metricNames;
  return metricNames;
};

/**
 * Get expression from MetricDefinition
 *
 * metricDefinitionToExpression :: MetricDefinition -> String
 * @function metricDefinitionToExpression
 * @param {MetricDefinition} metricDefinition
 * @returns {String}
 */
var metricDefinitionToExpression = function metricDefinitionToExpression() {
  var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricDefinition(),
    expression = _ref26.expression;
  return expression;
};

/**
 * Get name from Operation
 *
 * operationToName :: Operation -> String
 * @function operationToName
 * @param {Operation} operation
 * @returns {String}
 */
var operationToName = function operationToName() {
  var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Operation(),
    name = _ref27.name;
  return name;
};

/**
 * Get target from Operation
 *
 * operationToTarget :: Operation -> String
 * @function operationToTarget
 * @param {Operation} operation
 * @returns {String}
 */
var operationToTarget = function operationToTarget() {
  var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Operation(),
    target = _ref28.target;
  return target;
};

/**
 * Get operator from Operation
 *
 * operationToOperator :: Operation -> String
 * @function operationToOperator
 * @param {Operation} operation
 * @returns {String}
 */
var operationToOperator = function operationToOperator() {
  var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Operation(),
    operator = _ref29.operator;
  return operator;
};

/**
 * Get value from Operation
 *
 * operationToValue :: Operation -> String
 * @function operationToValue
 * @param {Operation} operation
 * @returns {String}
 */
var operationToValue = function operationToValue() {
  var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Operation(),
    value = _ref30.value;
  return value;
};

/**
 * Get type from Operation
 *
 * operationToType :: Operation -> String
 * @function operationToType
 * @param {Operation} operation
 * @returns {String}
 */
var operationToType = function operationToType() {
  var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Operation(),
    type = _ref31.type;
  return type;
};

/* eslint-disable no-unused-vars */
var UserPayModelBuilder = /*#__PURE__*/_createClass(
/**
 * Create a UserPayModelBuilder
 * @property {String} name
 * @property {String[]} employeeIds
 * @property {String} interval
 */
function UserPayModelBuilder() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var employeeIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  _classCallCheck(this, UserPayModelBuilder);
  /** @type {String} */
  this.name = name;
  /** @type {String[]} */
  this.employeeIds = employeeIds;
  /** @type {String} */
  this.interval = interval;
});
/** Class representing a UserPayModel */
var UserPayModel = /*#__PURE__*/_createClass(
/**
 * Create a UserPayModel
 *
 * A UserPayModel is an organizational container for Users and PayRules
 * used for grouping up instructions on how to pay for metrics with the same ID.
 * @property {String} name
 * @property {String[]} users
 * @property {DateRange} dateRange
 * @property {PayRule[]} payRules
 */
function UserPayModel() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var users = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var dateRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new DateRange();
  var payRules = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, UserPayModel);
  /** @type {String} */
  this.name = name;
  /** @type {String[]} */
  this.users = users;
  /** @type {DateRange} */
  this.dateRange = dateRange;
  /** @type {PayRule[]} */
  this.payRules = payRules;
});
/** Class representing a PayRule */
var PayRule = /*#__PURE__*/_createClass(
/**
 * Create a PayRule
 *
 * A PayRule is a Name, a set of Conditions required for the PayValue to be valid,
 * and a set of Adjustments to apply if the PayValue is valid.
 * @property {string} name
 * @property {Operation[]} conditions
 * @property {Operation[]} adjustments
 * @property {Date} startDate
 */
function PayRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var adjustments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var startDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Date();
  _classCallCheck(this, PayRule);
  /** @type {string} */
  this.name = name;
  /** @type {Operation[]} */
  this.conditions = conditions;
  /** @type {Operation[]} */
  this.adjustments = adjustments;
  /** @type {Date} */
  this.startDate = startDate;
});
/** Class representing a PayDescription */
var PayDescription = /*#__PURE__*/_createClass(
/**
 * Create a PayDescription
 * @property {string} payCode
 * @property {string} employeeId
 * @property {DateRange} dateRange
 */
function PayDescription() {
  var payCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var employeeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var dateRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new DateRange();
  _classCallCheck(this, PayDescription);
  /** @type {string} */
  this.payCode = payCode;
  /** @type {string} */
  this.employeeId = employeeId;
  /** @type {DateRange} */
  this.dateRange = dateRange;
});
/** Class representing a PayMetric */
var PayMetric = /*#__PURE__*/_createClass(
/**
 * Create a PayMetric
 *
 * A PayMetric is a Metric that is used to determine a User's pay.
 * @property {PayDescription} payDescription
 * @property {Metric} metric
 */
function PayMetric() {
  var payDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayDescription();
  var metric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Metric();
  _classCallCheck(this, PayMetric);
  /** @type {PayDescription} */
  this.payDescription = payDescription;
  /** @type {Metric} */
  this.metric = metric;
});
/** Class representing a PayCalculation */
var PayCalculation = /*#__PURE__*/_createClass(
/**
 * Create a PayCalculation
 *
 * A PayCalculation is an organizational container for a user's metrics by the ID.
 * @property {String} name
 * @property {String} employeeId
 * @property {DateRange} dateRange
 * @property {PayMetric[]} metrics
 * @property {PayRule[]} payRules
 */
function PayCalculation() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var employeeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var dateRange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new DateRange();
  var metrics = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var payRules = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  _classCallCheck(this, PayCalculation);
  /** @type {String} */
  this.name = name;
  /** @type {String} */
  this.employeeId = employeeId;
  /** @type {DateRange} */
  this.dateRange = dateRange;
  /** @type {PayMetric[]} */
  this.metrics = metrics;
  /** @type {PayRule[]} */
  this.payRules = payRules;
});
/** Class representing a PayRecord */
var PayRecord = /*#__PURE__*/_createClass(
/**
 * Create a PayRecord
 *
 * A PayRecord is a type of UserMetric that serves as an audit log of
 * what, how, and why we paid for a UserMetric.
 * @property {Operation[]} conditions
 * @property {Operation[]} adjustments
 * @property {String} earning
 * @property {String} payrate
 */
function PayRecord() {
  var conditions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var adjustments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var earning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var payrate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  _classCallCheck(this, PayRecord);
  /** @type {Operation[]} */
  this.conditions = conditions;
  /** @type {Operation[]} */
  this.adjustments = adjustments;
  /** @type {string} */
  this.earning = earning;
  /** @type {string} */
  this.payrate = payrate;
});
var UserPayPeriodData = /*#__PURE__*/_createClass(
/**
 * Create a UserPayPeriodData
 * @property {PayMetric[]} payMetrics
 * @property {PayRecord[]} payRecords
 * @property {PayRule[]} payRules
 * @property {DateRange} dateRange
 */
function UserPayPeriodData() {
  var payMetrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var payRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var payRules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var dateRange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new DateRange();
  _classCallCheck(this, UserPayPeriodData);
  /** @type {PayMetric[]} */
  this.payMetrics = payMetrics;
  /** @type {PayRecord[]} */
  this.payRecords = payRecords;
  /** @type {PayRule[]} */
  this.payRules = payRules;
  /** @type {DateRange} */
  this.dateRange = dateRange;
});
/** Class representing a PayRuleRow */
var PayRuleRow = /*#__PURE__*/_createClass(
/**
 * Create a PayRuleRow
 *
 * A PayRuleRow is a flattened version of a PayRule to be represented in a CSV.
 * @property {string} name
 * @property {string} date
 * @property {string} conditionName
 * @property {string} conditionTarget
 * @property {string} conditionOperation
 * @property {string} conditionValue
 * @property {string} adjustmentName
 * @property {string} adjustmentTarget
 * @property {string} adjustmentOperation
 * @property {string} adjustmentValue
 */
function PayRuleRow() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var conditionName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var conditionTarget = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var conditionOperation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var conditionValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var adjustmentName = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var adjustmentTarget = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var adjustmentOperation = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var adjustmentValue = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  _classCallCheck(this, PayRuleRow);
  /** @type {string} */
  this.name = name;
  /** @type {string} */
  this.date = date;
  /** @type {string} */
  this.conditionName = conditionName;
  /** @type {string} */
  this.conditionTarget = conditionTarget;
  /** @type {string} */
  this.conditionOperation = conditionOperation;
  /** @type {string} */
  this.conditionValue = conditionValue;
  /** @type {string} */
  this.adjustmentName = adjustmentName;
  /** @type {string} */
  this.adjustmentTarget = adjustmentTarget;
  /** @type {string} */
  this.adjustmentOperation = adjustmentOperation;
  /** @type {string} */
  this.adjustmentValue = adjustmentValue;
});
/* eslint-disable no-unused-vars */
/** Class representing a MetricCategory */
var MetricCategory = /*#__PURE__*/_createClass(
/**
 * Create MetricCategory
 * @property {String} categoryName
 * @property {MetricMetadata[]} metricMetadatas
 */
function MetricCategory() {
  var categoryName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricMetadatas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  _classCallCheck(this, MetricCategory);
  /** @type {String} */
  this.categoryName = categoryName;
  /** @type {MetricMetadata[]} */
  this.metricMetadatas = metricMetadatas;
});
/** Class representing a MetricMetadata */
var MetricMetadata = /*#__PURE__*/_createClass(
/**
 * Create MetricMetadata
 * @property {String} metricDisplayName
 * @property {String} metricDataName
 */
function MetricMetadata() {
  var metricDisplayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricDataName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, MetricMetadata);
  /** @type {String} */
  this.metricDisplayName = metricDisplayName;
  /** @type {String} */
  this.metricDataName = metricDataName;
});
/** Class representing a PayPeriodInformation */
var PayPeriodInformation = /*#__PURE__*/_createClass(
/**
 * Create a PayPeriodInformation
 * @property {String} employeeId
 * @property {String} employeeName
 * @property {PayPeriod} payPeriod
 * @property {Number} totalEarnings
 * @property {Number} totalSales
 * @property {Number} totalSessions
 * @property {MetricInformation[]} metricInformations
 * @property {PayMetric[]} payMetrics
 * @property {PayRule[]} payRules
 */
function PayPeriodInformation() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var employeeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var payPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new PayPeriod();
  var totalEarnings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var totalSales = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var totalSessions = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var metricInformations = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
  var payMetrics = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var payRules = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
  _classCallCheck(this, PayPeriodInformation);
  /** @type {String} */
  this.employeeId = employeeId;
  /** @type {String} */
  this.employeeName = employeeName;
  /** @type {PayPeriod} */
  this.payPeriod = payPeriod;
  /** @type {Number} */
  this.totalEarnings = totalEarnings;
  /** @type {Number} */
  this.totalSales = totalSales;
  /** @type {Number} */
  this.totalSessions = totalSessions;
  /** @type {MetricInformation[]} */
  this.metricInformations = metricInformations;
  /** @type {PayMetric[]} */
  this.payMetrics = payMetrics;
  /** @type {PayRule[]} */
  this.payRules = payRules;
});
/** Class representing a MetricInformation */
var MetricInformation = /*#__PURE__*/_createClass(
/**
 * Create a MetricInformation
 * @property {String} metricDisplayName
 * @property {String} categoryName
 * @property {Number} metricValue
 * @property {Number} metricMultiplier
 * @property {String} metricType
 * @property {Number} payRate
 * @property {Number} earning
 * @property {PayRule[]} payRules
 * @property {String} metricTrueName
 */
function MetricInformation() {
  var metricDisplayName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var categoryName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var metricValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var metricMultiplier = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var metricType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var payRate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var earning = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var payRules = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  var metricTrueName = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  _classCallCheck(this, MetricInformation);
  /** @type {String} */
  this.metricDisplayName = metricDisplayName;
  /** @type {String} */
  this.categoryName = categoryName;
  /** @type {Number} */
  this.metricValue = metricValue;
  /** @type {Number} */
  this.metricMultiplier = metricMultiplier;
  /** @type {String} */
  this.metricType = metricType;
  /** @type {Number} */
  this.payRate = payRate;
  /** @type {Number} */
  this.earning = earning;
  /** @type {PayRule[]} */
  this.payRules = payRules;
  /** @type {String} */
  this.metricTrueName = metricTrueName;
});
/** Class representing a PayViewData */
var PayViewData = /*#__PURE__*/_createClass(
/**
 * Create a PayViewData
 * @property {string} employeeId
 * @property {string} employeeName
 * @property {PayPeriodData[]} employeePayPeriods
 * @property {TeamMemberPayData[]} teamMemberPayData
 */
function PayViewData() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var employeeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var employeePayPeriods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var teamMemberPayData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, PayViewData);
  /** @type {string} */
  this.employeeId = employeeId;
  /** @type {string} */
  this.employeeName = employeeName;
  /** @type {PayPeriodData[]} */
  this.employeePayPeriods = employeePayPeriods;
  /** @type {TeamMemberPayData[]} */
  this.teamMemberPayData = teamMemberPayData;
});
/** Class representing a TeamMemberPayData */
var TeamMemberPayData = /*#__PURE__*/_createClass(
/**
 * Create a TeamMemberPayData
 * @param {string} employeeId
 * @param {string} name
 * @param {PayPeriodData[]} payPeriods
 */
function TeamMemberPayData() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var payPeriods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  _classCallCheck(this, TeamMemberPayData);
  /** @type {string} */
  this.employeeId = employeeId;
  /** @type {string} */
  this.name = name;
  /** @type {PayPeriodData[]} */
  this.payPeriods = payPeriods;
});
/** Class representing a PayPeriodData */
var PayPeriodData = /*#__PURE__*/_createClass(
/**
 * Create a PayPeriodData
 * @param {PayPeriod} payPeriod
 * @param {string} source
 * @param {EarningsData} earnings
 * @param {PerformanceCategory[]} performance
 */
function PayPeriodData() {
  var payPeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriod();
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var earnings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new EarningsData();
  var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, PayPeriodData);
  /** @type {PayPeriod} */
  this.payPeriod = payPeriod;
  /** @type {string} */
  this.source = source;
  /** @type {EarningsData} */
  this.earnings = earnings;
  /** @type {PerformanceCategory[]} */
  this.performance = performance;
});
/** Class representing a PayPeriod */
var PayPeriod = /*#__PURE__*/_createClass(
/**
 * Create a PayPeriod
 * @param {string} startDate
 * @param {string} endDate
 */
function PayPeriod() {
  var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  _classCallCheck(this, PayPeriod);
  /** @type {string} */
  this.startDate = startDate;
  /** @type {string} */
  this.endDate = endDate;
});
/** Class representing an EarningsData */
var EarningsData = /*#__PURE__*/_createClass(
/**
 * Create an EarningsData
 * @param {number} totalEarnings
 * @param {number} totalSales
 * @param {number} totalSessions
 * @param {EarningsCategory[]} earningsCategories
 */
function EarningsData() {
  var totalEarnings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var totalSales = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var totalSessions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var earningsCategories = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, EarningsData);
  /** @type {number} */
  this.totalEarnings = totalEarnings;
  /** @type {number} */
  this.totalSales = totalSales;
  /** @type {number} */
  this.totalSessions = totalSessions;
  /** @type {EarningsCategory[]} */
  this.earningsCategories = earningsCategories;
});
/** Class representing an EarningsCategory */
var EarningsCategory = /*#__PURE__*/_createClass(
/**
 * Create an EarningsCategory
 * @param {string} title
 * @param {number} categoryTotal
 * @param {MetricEarningsData[]} metrics
 */
function EarningsCategory() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var categoryTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var metrics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  _classCallCheck(this, EarningsCategory);
  /** @type {string} */
  this.title = title;
  /** @type {number} */
  this.categoryTotal = categoryTotal;
  /** @type {MetricEarningsData[]} */
  this.metrics = metrics;
});
/** Class representing a MetricEarningsData */
var MetricEarningsData = /*#__PURE__*/_createClass(
/**
 * Create a MetricEarningsData
 * @param {string} metricName
 * @param {number} metricQuantity
 * @param {number} metricAmountPer
 * @param {number} metricTotalEarnings
 */
function MetricEarningsData() {
  var metricName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var metricAmountPer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var metricTotalEarnings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  _classCallCheck(this, MetricEarningsData);
  /** @type {string} */
  this.metricName = metricName;
  /** @type {number} */
  this.metricQuantity = metricQuantity;
  /** @type {number} */
  this.metricAmountPer = metricAmountPer;
  /** @type {number} */
  this.metricTotalEarnings = metricTotalEarnings;
});
/** Class representing a PerformanceCategory */
var PerformanceCategory = /*#__PURE__*/_createClass(
/**
 * Create a PerformanceCategory
 * @param {string} name
 * @param {number} categoryTotalQuantity
 * @param {string} categoryTotalUnitType
 * @param {DashboardMetric[]} metrics
 */
function PerformanceCategory() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var categoryTotalQuantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var categoryTotalUnitType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var metrics = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  _classCallCheck(this, PerformanceCategory);
  /** @type {string} */
  this.name = name;
  /** @type {number} */
  this.categoryTotalQuantity = categoryTotalQuantity;
  /** @type {string} */
  this.categoryTotalUnitType = categoryTotalUnitType;
  /** @type {DashboardMetric[]} */
  this.metrics = metrics;
});
/** Class representing a DashboardMetric */
var DashboardMetric = /*#__PURE__*/_createClass(
/**
 * Create a DashboardMetric
 * @param {string} metricName
 * @param {number} metricValue
 * @param {number} metricQuantity
 * @param {string} unitType
 * @param {number} payTotal
 * @param {number} absoluteMin
 * @param {number} absoluteMax
 * @param {Tier[]} tiers
 */
function DashboardMetric() {
  var metricName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var metricQuantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var unitType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var payTotal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var absoluteMin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var absoluteMax = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 100;
  var tiers = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
  _classCallCheck(this, DashboardMetric);
  /** @type {string} */
  this.metricName = metricName;
  /** @type {number} */
  this.metricValue = metricValue;
  /** @type {number} */
  this.metricQuantity = metricQuantity;
  /** @type {string} */
  this.unitType = unitType;
  /** @type {number} */
  this.payTotal = payTotal;
  /** @type {number} */
  this.absoluteMin = absoluteMin;
  /** @type {number} */
  this.absoluteMax = absoluteMax;
  /** @type {Tier[]} */
  this.tiers = tiers;
});
var Tier = /*#__PURE__*/_createClass(
/**
 * Create a Tier
 * @param {Number} value
 * @param {Number} payAmount
 */
function Tier() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var payAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  _classCallCheck(this, Tier);
  /** @type {Number} */
  this.value = value;
  /** @type {Number} */
  this.payAmount = payAmount;
});
var DashboardPrimer = /*#__PURE__*/_createClass(
/**
 * Create a DashboardPrimer
 * @property {String[]} employeeIds
 */
function DashboardPrimer() {
  var employeeIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  _classCallCheck(this, DashboardPrimer);
  /** @type {String[]} */
  this.employeeIds = employeeIds;
});
/** Class representing a MetricCategoryRow */
var MetricCategoryRow = /*#__PURE__*/_createClass(
/**
 * Create MetricCategoryRow
 * @property {String} category
 * @property {String} metricDisplayName
 * @property {String} metricDataName
 */
function MetricCategoryRow() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricDisplayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var metricDataName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  _classCallCheck(this, MetricCategoryRow);
  /** @type {String} */
  this.category = category;
  /** @type {String} */
  this.metricDisplayName = metricDisplayName;
  /** @type {String} */
  this.metricDataName = metricDataName;
});
/** Class representing a UserPayPeriodDataRow */
var UserPayPeriodDataRow = /*#__PURE__*/_createClass(
/**
 * Create UserPayPeriodDataRow
 * @param {String} employeeId
 * @param {String} startDate
 * @param {String} endDate
 * @param {String} payModelName
 * @param {String} totalCalls
 * @param {String} sales
 * @param {String} totalPay
 * @param {String} serveMetricName
 * @param {String} serveValue
 * @param {String} servePay
 * @param {String} sp100MetricName
 * @param {String} sp100Value
 * @param {String} sp100Pay
 * @param {String} heroValue
 * @param {String} heroPay
 * @param {PayMetricDetail[]} payMetricDetails
 * @param {PayRuleDetail[]} payRuleDetails
 */
function UserPayPeriodDataRow() {
  var employeeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var payModelName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var totalCalls = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var sales = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var totalPay = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var serveMetricName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var serveValue = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var servePay = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var sp100MetricName = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';
  var sp100Value = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '';
  var sp100Pay = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : '';
  var heroValue = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : '';
  var heroPay = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : '';
  var payMetricDetails = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : [];
  var payRuleDetails = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : [];
  _classCallCheck(this, UserPayPeriodDataRow);
  /** @type {String} */
  this.employeeId = employeeId;
  /** @type {String} */
  this.startDate = startDate;
  /** @type {String} */
  this.endDate = endDate;
  /** @type {String} */
  this.payModelName = payModelName;
  /** @type {String} */
  this.totalCalls = totalCalls;
  /** @type {String} */
  this.sales = sales;
  /** @type {String} */
  this.totalPay = totalPay;
  /** @type {String} */
  this.serveMetricName = serveMetricName;
  /** @type {String} */
  this.serveValue = serveValue;
  /** @type {String} */
  this.servePay = servePay;
  /** @type {String} */
  this.sp100MetricName = sp100MetricName;
  /** @type {String} */
  this.sp100Value = sp100Value;
  /** @type {String} */
  this.sp100Pay = sp100Pay;
  /** @type {String} */
  this.heroValue = heroValue;
  /** @type {String} */
  this.heroPay = heroPay;
  /** @type {PayMetricDetail[]} */
  this.payMetricDetails = payMetricDetails;
  /** @type {PayRuleDetail[]} */
  this.payRuleDetails = payRuleDetails;
});
/** Class representing a PayMetricDetail */
var PayMetricDetail = /*#__PURE__*/_createClass(
/**
 * Create PayMetricDetail
 * @param {String} metricName
 * @param {String} metricValue
 * @param {String} startDate
 * @param {String} endDate
 */
function PayMetricDetail() {
  var metricName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var metricValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var startDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var endDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  _classCallCheck(this, PayMetricDetail);
  /** @type {String} */
  this.metricName = metricName;
  /** @type {String} */
  this.metricValue = metricValue;
  /** @type {String} */
  this.startDate = startDate;
  /** @type {String} */
  this.endDate = endDate;
});
/** Class representing a PayRuleDetail */
var PayRuleDetail = /*#__PURE__*/_createClass(
/**
 *
 * @param {String} payRuleName
 * @param {String} conditionFormula
 * @param {String} payFormula
 */
function PayRuleDetail() {
  var payRuleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var conditionFormula = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var payFormula = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  _classCallCheck(this, PayRuleDetail);
  /** @type {String} */
  this.payRuleName = payRuleName;
  /** @type {String} */
  this.conditionFormula = conditionFormula;
  /** @type {String} */
  this.payFormula = payFormula;
});
/** Class representing a PayRuleAndPayMetricDetail */
var PayRuleAndPayMetricDetail = /*#__PURE__*/_createClass(
/**
 * @param {String} payRuleName
 * @param {String} conditionFormula
 * @param {String} payFormula
 * @param {String} metricName
 * @param {String} metricValue
 * @param {String} startDate
 * @param {String} endDate
 */
function PayRuleAndPayMetricDetail() {
  var payRuleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var conditionFormula = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var payFormula = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var metricName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var metricValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var startDate = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var endDate = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  _classCallCheck(this, PayRuleAndPayMetricDetail);
  /** @type {String} */
  this.payRuleName = payRuleName;
  /** @type {String} */
  this.conditionFormula = conditionFormula;
  /** @type {String} */
  this.payFormula = payFormula;
  /** @type {String} */
  this.metricName = metricName;
  /** @type {String} */
  this.metricValue = metricValue;
  /** @type {String} */
  this.startDate = startDate;
  /** @type {String} */
  this.endDate = endDate;
});
/* eslint-disable no-unused-vars */
/**
 * Get categoryName from MetricCategory
 *
 * metricCategoryToCategoryName :: MetricCategory -> String
 * @function metricCategoryToCategoryName
 * @param {MetricCategory} metricCategory
 * @returns {String}
 */
var metricCategoryToCategoryName = function metricCategoryToCategoryName() {
  var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricCategory(),
    categoryName = _ref32.categoryName;
  return categoryName;
};

/**
 * Get metricMetadatas from MetricCategory
 *
 * metricCategoryToMetricMetadatas :: MetricCategory -> [MetricMetadata]
 * @function metricCategoryToMetricMetadatas
 * @param {MetricCategory} metricCategory
 * @returns {MetricMetadata[]}
 */
var metricCategoryToMetricMetadatas = function metricCategoryToMetricMetadatas() {
  var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricCategory(),
    metricMetadatas = _ref33.metricMetadatas;
  return metricMetadatas;
};

/**
 * Get metricDisplayName from MetricMetadata
 *
 * metricMetadataToMetricDisplayName :: MetricMetadata -> String
 * @function metricMetadataToMetricDisplayName
 * @param {MetricMetadata} metricCategory
 * @returns {String}
 */
var metricMetadataToMetricDisplayName = function metricMetadataToMetricDisplayName() {
  var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricMetadata(),
    metricDisplayName = _ref34.metricDisplayName;
  return metricDisplayName;
};

/**
 * Get metricDataName from MetricMetadata
 *
 * metricMetadataToMetricDataName :: MetricMetadata -> String
 * @function metricMetadataToMetricDataName
 * @param {MetricMetadata} metricCategory
 * @returns {String}
 */
var metricMetadataToMetricDataName = function metricMetadataToMetricDataName() {
  var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricMetadata(),
    metricDataName = _ref35.metricDataName;
  return metricDataName;
};

/**
 * Get employeeId from MetricMetadata
 *
 * payPeriodInformationToEmployeeId :: PayPeriodInformation -> String
 * @function payPeriodInformationToEmployeeId
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {String}
 */
var payPeriodInformationToEmployeeId = function payPeriodInformationToEmployeeId() {
  var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    employeeId = _ref36.employeeId;
  return employeeId;
};

/**
 * Get employeeName from MetricMetadata
 *
 * payPeriodInformationToEmployeeName :: PayPeriodInformation -> String
 * @function payPeriodInformationToEmployeeName
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {String}
 */
var payPeriodInformationToEmployeeName = function payPeriodInformationToEmployeeName() {
  var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    employeeName = _ref37.employeeName;
  return employeeName;
};

/**
 * Get payPeriod from MetricMetadata
 *
 * payPeriodInformationToPayPeriod :: PayPeriodInformation -> PayPeriod
 * @function payPeriodInformationToPayPeriod
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {PayPeriod}
 */
var payPeriodInformationToPayPeriod = function payPeriodInformationToPayPeriod() {
  var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    payPeriod = _ref38.payPeriod;
  return payPeriod;
};

/**
 * Get totalEarnings from MetricMetadata
 *
 * payPeriodInformationToTotalEarnings :: PayPeriodInformation -> Number
 * @function payPeriodInformationToTotalEarnings
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {Number}
 */
var payPeriodInformationToTotalEarnings = function payPeriodInformationToTotalEarnings() {
  var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    totalEarnings = _ref39.totalEarnings;
  return totalEarnings;
};

/**
 * Get totalSales from MetricMetadata
 *
 * payPeriodInformationToTotalSales :: PayPeriodInformation -> Number
 * @function payPeriodInformationToTotalSales
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {Number}
 */
var payPeriodInformationToTotalSales = function payPeriodInformationToTotalSales() {
  var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    totalSales = _ref40.totalSales;
  return totalSales;
};

/**
 * Get totalSessions from MetricMetadata
 *
 * payPeriodInformationToTotalSessions :: PayPeriodInformation -> Number
 * @function payPeriodInformationToTotalSessions
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {Number}
 */
var payPeriodInformationToTotalSessions = function payPeriodInformationToTotalSessions() {
  var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    totalSessions = _ref41.totalSessions;
  return totalSessions;
};

/**
 * Get metricInformations from MetricMetadata
 *
 * payPeriodInformationToMetricInformations :: PayPeriodInformation -> [MetricInformation]
 * @function payPeriodInformationToMetricInformations
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {MetricInformation[]}
 */
var payPeriodInformationToMetricInformations = function payPeriodInformationToMetricInformations() {
  var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    metricInformations = _ref42.metricInformations;
  return metricInformations;
};

/**
 * Get payRules from MetricMetadata
 *
 * payPeriodInformationToPayRules :: PayPeriodInformation -> [PayRule]
 * @function payPeriodInformationToPayRules
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {PayRule[]}
 */
var payPeriodInformationToPayRules = function payPeriodInformationToPayRules() {
  var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    payRules = _ref43.payRules;
  return payRules;
};

/**
 * Get payMetrics from MetricMetadata
 *
 * payPeriodInformationToPayMetrics :: PayPeriodInformation -> [PayMetric]
 * @function payPeriodInformationToPayMetrics
 * @param {PayPeriodInformation} payPeriodInformation
 * @returns {PayMetric[]}
 */
var payPeriodInformationToPayMetrics = function payPeriodInformationToPayMetrics() {
  var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodInformation(),
    payMetrics = _ref44.payMetrics;
  return payMetrics;
};

/**
 * Get metricDisplayName from MetricMetadata
 *
 * metricInformationToMetricDisplayName :: MetricInformation -> String
 * @function metricInformationToMetricDisplayName
 * @param {MetricInformation} metricInformation
 * @returns {String}
 */
var metricInformationToMetricDisplayName = function metricInformationToMetricDisplayName() {
  var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    metricDisplayName = _ref45.metricDisplayName;
  return metricDisplayName;
};

/**
 * Get categoryName from MetricMetadata
 *
 * metricInformationToCategoryName :: MetricInformation -> String
 * @function metricInformationToCategoryName
 * @param {MetricInformation} metricInformation
 * @returns {String}
 */
var metricInformationToCategoryName = function metricInformationToCategoryName() {
  var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    categoryName = _ref46.categoryName;
  return categoryName;
};

/**
 * Get metricValue from MetricMetadata
 *
 * metricInformationToMetricValue :: MetricInformation -> Number
 * @function metricInformationToMetricValue
 * @param {MetricInformation} metricInformation
 * @returns {Number}
 */
var metricInformationToMetricValue = function metricInformationToMetricValue() {
  var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    metricValue = _ref47.metricValue;
  return metricValue;
};

/**
 * Get metricMultiplier from MetricMetadata
 *
 * metricInformationToMetricMultiplier :: MetricInformation -> Number
 * @function metricInformationToMetricMultiplier
 * @param {MetricInformation} metricInformation
 * @returns {Number}
 */
var metricInformationToMetricMultiplier = function metricInformationToMetricMultiplier() {
  var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    metricMultiplier = _ref48.metricMultiplier;
  return metricMultiplier;
};

/**
 * Get metricType from MetricMetadata
 *
 * metricInformationToMetricType :: MetricInformation -> String
 * @function metricInformationToMetricType
 * @param {MetricInformation} metricInformation
 * @returns {String}
 */
var metricInformationToMetricType = function metricInformationToMetricType() {
  var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    metricType = _ref49.metricType;
  return metricType;
};

/**
 * Get payRate from MetricMetadata
 *
 * metricInformationToPayRate :: MetricInformation -> Number
 * @function metricInformationToPayRate
 * @param {MetricInformation} metricInformation
 * @returns {Number}
 */
var metricInformationToPayRate = function metricInformationToPayRate() {
  var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    payRate = _ref50.payRate;
  return payRate;
};

/**
 * Get earning from MetricMetadata
 *
 * metricInformationToEarning :: MetricInformation -> Number
 * @function metricInformationToEarning
 * @param {MetricInformation} metricInformation
 * @returns {Number}
 */
var metricInformationToEarning = function metricInformationToEarning() {
  var _ref51 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    earning = _ref51.earning;
  return earning;
};

/**
 * Get payRules from MetricMetadata
 *
 * metricInformationToPayRules :: MetricInformation -> [PayRule]
 * @function metricInformationToPayRules
 * @param {MetricInformation} metricInformation
 * @returns {PayRule[]}
 */
var metricInformationToPayRules = function metricInformationToPayRules() {
  var _ref52 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    payRules = _ref52.payRules;
  return payRules;
};

/**
 * Get metricTrueName from MetricMetadata
 *
 * metricInformationToMetricTrueName :: MetricInformation -> String
 * @function metricInformationToMetricTrueName
 * @param {MetricInformation} metricInformation
 * @returns {String}
 */
var metricInformationToMetricTrueName = function metricInformationToMetricTrueName() {
  var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricInformation(),
    metricTrueName = _ref53.metricTrueName;
  return metricTrueName;
};

/**
 * Get category from MetricCategoryRow
 *
 * metricCategoryRowToCategory :: MetricCategoryRow -> String
 * @function metricCategoryRowToCategory
 * @param {MetricCategoryRow} metricCategoryRow
 * @returns {String}
 */
var metricCategoryRowToCategory = function metricCategoryRowToCategory() {
  var _ref54 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricCategoryRow(),
    category = _ref54.category;
  return category;
};

/**
 * Get metricDisplayName from MetricCategoryRow
 *
 * metricCategoryRowToMetricDisplayName :: MetricCategoryRow -> String
 * @function metricCategoryRowToMetricDisplayName
 * @param {MetricCategoryRow} metricCategoryRow
 * @returns {String}
 */
var metricCategoryRowToMetricDisplayName = function metricCategoryRowToMetricDisplayName() {
  var _ref55 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricCategoryRow(),
    metricDisplayName = _ref55.metricDisplayName;
  return metricDisplayName;
};

/**
 * Get metricDataName from MetricCategoryRow
 *
 * metricCategoryRowToMetricDataName :: MetricCategoryRow -> String
 * @function metricCategoryRowToMetricDataName
 * @param {MetricCategoryRow} metricCategoryRow
 * @returns {String}
 */
var metricCategoryRowToMetricDataName = function metricCategoryRowToMetricDataName() {
  var _ref56 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricCategoryRow(),
    metricDataName = _ref56.metricDataName;
  return metricDataName;
};

/**
 * @function dashboardPrimerToEmployeeIds
 * DashboardThing -> String[]
 * @param {DashboardPrimer} dashboardPrimer
 * @returns {String[]}
 */
var dashboardPrimerToEmployeeIds = function dashboardPrimerToEmployeeIds() {
  var _ref57 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardPrimer(),
    employeeIds = _ref57.employeeIds;
  return employeeIds;
};

/**
 * @function dashboardMetricToMetricName
 * DashboardMetric -> String
 * @param {DashboardMetric} dashboardMetric
 * @returns {String}
 */
var dashboardMetricToMetricName = function dashboardMetricToMetricName() {
  var _ref58 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    metricName = _ref58.metricName;
  return metricName;
};

/**
 * @function dashboardMetricToMetricValue
 * DashboardMetric -> Number
 * @param {DashboardMetric} dashboardMetric
 * @returns {Number}
 */
var dashboardMetricToMetricValue = function dashboardMetricToMetricValue() {
  var _ref59 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    metricValue = _ref59.metricValue;
  return metricValue;
};

/**
 * @function dashboardMetricToMetricQuantity
 * DashboardMetric -> Number
 * @param {DashboardMetric} dashboardMetric
 * @returns {Number}
 */
var dashboardMetricToMetricQuantity = function dashboardMetricToMetricQuantity() {
  var _ref60 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    metricQuantity = _ref60.metricQuantity;
  return metricQuantity;
};

/**
 * @function dashboardMetricToMetricName
 * DashboardMetric -> String
 * @param {DashboardMetric} dashboardMetric
 * @returns {String}
 */
var dashboardMetricToUnitType = function dashboardMetricToUnitType() {
  var _ref61 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    unitType = _ref61.unitType;
  return unitType;
};

/**
 * @function dashboardMetricToPayTotal
 * DashboardMetric -> Number
 * @param {DashboardMetric} dashboardMetric
 * @returns {Number}
 */
var dashboardMetricToPayTotal = function dashboardMetricToPayTotal() {
  var _ref62 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    payTotal = _ref62.payTotal;
  return payTotal;
};

/**
 * @function dashboardMetricToAbsoluteMin
 * DashboardMetric -> Number
 * @param {DashboardMetric} dashboardMetric
 * @returns {Number}
 */
var dashboardMetricToAbsoluteMin = function dashboardMetricToAbsoluteMin() {
  var _ref63 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    absoluteMin = _ref63.absoluteMin;
  return absoluteMin;
};

/**
 * @function dashboardMetricToAbsoluteMax
 * DashboardMetric -> Number
 * @param {DashboardMetric} dashboardMetric
 * @returns {Number}
 */
var dashboardMetricToAbsoluteMax = function dashboardMetricToAbsoluteMax() {
  var _ref64 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    absoluteMax = _ref64.absoluteMax;
  return absoluteMax;
};

/**
 * @function dashboardMetricToTiers
 * DashboardMetric -> Tier[]
 * @param {DashboardMetric} dashboardMetric
 * @returns {Tier[]}
 */
var dashboardMetricToTiers = function dashboardMetricToTiers() {
  var _ref65 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric(),
    tiers = _ref65.tiers;
  return tiers;
};

/**
 * @function tierToValue
 * Tier -> Number
 * @param {Tier} tier
 * @returns {Number}
 */
var tierToValue = function tierToValue() {
  var _ref66 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tier(),
    value = _ref66.value;
  return value;
};

/**
 * @function tierToPayAmount
 * Tier -> Number
 * @param {Tier} tier
 * @returns {Number}
 */
var tierToPayAmount = function tierToPayAmount() {
  var _ref67 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tier(),
    payAmount = _ref67.payAmount;
  return payAmount;
};

/**
 * @function performanceCategoryToName
 * PerformanceCategory -> String
 * @param {PerformanceCategory} performanceCategory
 * @returns {String}
 */
var performanceCategoryToName = function performanceCategoryToName() {
  var _ref68 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    name = _ref68.name;
  return name;
};

/**
 * @function performanceCategoryToCategoryTotalQuantity
 * PerformanceCategory -> Number
 * @param {PerformanceCategory} performanceCategory
 * @returns {Number}
 */
var performanceCategoryToCategoryTotalQuantity = function performanceCategoryToCategoryTotalQuantity() {
  var _ref69 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    categoryTotalQuantity = _ref69.categoryTotalQuantity;
  return categoryTotalQuantity;
};

/**
 * @function performanceCategoryToCategoryTotalUnitType
 * PerformanceCategory -> String
 * @param {PerformanceCategory} performanceCategory
 * @returns {String}
 */
var performanceCategoryToCategoryTotalUnitType = function performanceCategoryToCategoryTotalUnitType() {
  var _ref70 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    categoryTotalUnitType = _ref70.categoryTotalUnitType;
  return categoryTotalUnitType;
};

/**
 * @function performanceCategoryToMetrics
 * PerformanceCategory -> DashboardMetric[]
 * @param {PerformanceCategory} performanceCategory
 * @returns {DashboardMetric[]}
 */
var performanceCategoryToMetrics = function performanceCategoryToMetrics() {
  var _ref71 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory(),
    metrics = _ref71.metrics;
  return metrics;
};

/**
 * @function payPeriodDataToPayPeriod
 * PayPeriodData -> PayPeriod
 * @param {PayPeriodData} payPeriodData
 * @returns {PayPeriod}
 */
var payPeriodDataToPayPeriod = function payPeriodDataToPayPeriod() {
  var _ref72 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    payPeriod = _ref72.payPeriod;
  return payPeriod;
};

/**
 * @function payPeriodDataToSource
 * PayPeriodData -> String
 * @param {PayPeriodData} payPeriodData
 * @returns {String}
 */
var payPeriodDataToSource = function payPeriodDataToSource() {
  var _ref73 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    source = _ref73.source;
  return source;
};

/**
 * @function payPeriodDataToEarnings
 * PayPeriodData -> String
 * @param {PayPeriodData} payPeriodData
 * @returns {EarningsData}
 */
var payPeriodDataToEarnings = function payPeriodDataToEarnings() {
  var _ref74 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    earnings = _ref74.earnings;
  return earnings;
};

/**
 * @function payPeriodDataToPerformance
 * PayPeriodData -> PerformanceCategory[]
 * @param {PayPeriodData} payPeriodData
 * @returns {PerformanceCategory[]}
 */
var payPeriodDataToPerformance = function payPeriodDataToPerformance() {
  var _ref75 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData(),
    performance = _ref75.performance;
  return performance;
};

/**
 * @function payViewDataToEmployeeId
 * PayViewData -> String
 * @param {PayViewData} payViewData
 * @returns {String}
 */
var payViewDataToEmployeeId = function payViewDataToEmployeeId() {
  var _ref76 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    employeeId = _ref76.employeeId;
  return employeeId;
};

/**
 * @function payViewDataToEmployeeName
 * PayViewData -> String
 * @param {PayViewData} payViewData
 * @returns {String}
 */
var payViewDataToEmployeeName = function payViewDataToEmployeeName() {
  var _ref77 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    employeeName = _ref77.employeeName;
  return employeeName;
};

/**
 * @function payViewDataToEmployeePayPeriods
 * PayViewData -> PayPeriodData[]
 * @param {PayViewData} payViewData
 * @returns {PayPeriodData[]}
 */
var payViewDataToEmployeePayPeriods = function payViewDataToEmployeePayPeriods() {
  var _ref78 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    employeePayPeriods = _ref78.employeePayPeriods;
  return employeePayPeriods;
};

/**
 * @function payViewDataToTeamMemberPayDatas
 * PayViewData -> TeamMemberPayData[]
 * @param {PayViewData} payViewData
 * @returns {TeamMemberPayData[]}
 */
var payViewDataToTeamMemberPayDatas = function payViewDataToTeamMemberPayDatas() {
  var _ref79 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData(),
    teamMemberPayData = _ref79.teamMemberPayData;
  return teamMemberPayData;
};

/**
 * @function tierAndTierToNumber
 * Tier -> Tier -> Number
 * @param {Tier} tierA
 * @param {Tier} tierB
 * @returns {Number}
 */
var tierAndTierToNumber = function tierAndTierToNumber() {
  var tierA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Tier();
  var tierB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Tier();
  return tierToValue(tierA) - tierToValue(tierB);
};

/**
 * @function tiersToAscendingTiers
 * Tier[] -> Tier[]
 * @param {Tier[]} tiers
 * @returns {Tier[]}
 */
var tiersToAscendingTiers = function tiersToAscendingTiers() {
  var tiers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return tiers.sort(tierAndTierToNumber);
};

/**
 * @function dashboardMetricToDashboardMetricWithAscendingTiers
 * DashboardMetric -> DashboardMetric
 * @param {DashboardMetric} dashboardMetric
 * @returns {DashboardMetric}
 */
var dashboardMetricToDashboardMetricWithAscendingTiers = function dashboardMetricToDashboardMetricWithAscendingTiers() {
  var dashboardMetric = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new DashboardMetric();
  return new DashboardMetric(dashboardMetricToMetricName(dashboardMetric), dashboardMetricToMetricValue(dashboardMetric), dashboardMetricToMetricQuantity(dashboardMetric), dashboardMetricToUnitType(dashboardMetric), dashboardMetricToPayTotal(dashboardMetric), dashboardMetricToAbsoluteMin(dashboardMetric), dashboardMetricToAbsoluteMax(dashboardMetric), tiersToAscendingTiers(dashboardMetricToTiers(dashboardMetric)));
};

/**
 * @function performanceCategoryToPerformanceCategoryWithSortedDashboardMetrics
 * PerformanceCategory -> PerformanceCategory
 * @param {PerformanceCategory} performanceCategory
 * @returns {PerformanceCategory}
 */
var performanceCategoryToPerformanceCategoryWithSortedDashboardMetrics = function performanceCategoryToPerformanceCategoryWithSortedDashboardMetrics() {
  var performanceCategory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceCategory();
  return new PerformanceCategory(performanceCategoryToName(performanceCategory), performanceCategoryToCategoryTotalQuantity(performanceCategory), performanceCategoryToCategoryTotalUnitType(performanceCategory), performanceCategoryToMetrics(performanceCategory).map(dashboardMetricToDashboardMetricWithAscendingTiers));
};

/**
 * @function performanceCategoriesToPerformanceCategoriesWithSortedDashboardMetrics
 * PerformanceCategory[] -> PerformanceCategory[]
 * @param {PerformanceCategory[]} performanceCategories
 * @returns {PerformanceCategory[]}
 */
var performanceCategoriesToPerformanceCategoriesWithSortedDashboardMetrics = function performanceCategoriesToPerformanceCategoriesWithSortedDashboardMetrics() {
  var performanceCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return performanceCategories.map(performanceCategoryToPerformanceCategoryWithSortedDashboardMetrics);
};

/**
 * @function payPeriodDataToPayPeriodDataWithSortedDashboardMetrics
 * PayPeriodData -> PayPeriodData
 * @param {PayPeriodData} payPeriodData
 * @returns {PayPeriodData}
 */
var payPeriodDataToPayPeriodDataWithSortedDashboardMetrics = function payPeriodDataToPayPeriodDataWithSortedDashboardMetrics() {
  var payPeriodData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriodData();
  return new PayPeriodData(payPeriodDataToPayPeriod(payPeriodData), payPeriodDataToSource(payPeriodData), payPeriodDataToEarnings(payPeriodData), performanceCategoriesToPerformanceCategoriesWithSortedDashboardMetrics(payPeriodDataToPerformance(payPeriodData)));
};

/**
 * @function payPeriodDatasToPayPeriodDatasWithSortedDashboardMetrics
 * PayPeriodData[] -> PayPeriodData[]
 * @param {PayPeriodData[]} payPeriodDatas
 * @returns {PayPeriodData[]}
 */
var payPeriodDatasToPayPeriodDatasWithSortedDashboardMetrics = function payPeriodDatasToPayPeriodDatasWithSortedDashboardMetrics() {
  var payPeriodDatas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return payPeriodDatas.map(payPeriodDataToPayPeriodDataWithSortedDashboardMetrics);
};

/**
 * @function payViewDataToPayViewDataWithSortedDashboardMetrics
 * PayViewData -> PayViewData
 * @param {PayViewData} payViewData
 * @returns {PayViewData}
 */
var payViewDataToPayViewDataWithSortedDashboardMetrics = function payViewDataToPayViewDataWithSortedDashboardMetrics() {
  var payViewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayViewData();
  return new PayViewData(payViewDataToEmployeeId(payViewData), payViewDataToEmployeeName(payViewData), payPeriodDatasToPayPeriodDatasWithSortedDashboardMetrics(payViewDataToEmployeePayPeriods(payViewData)), payViewDataToTeamMemberPayDatas(payViewData));
};

/**
 * @function userPayPeriodDataRowToEmployeeId
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToEmployeeId = function userPayPeriodDataRowToEmployeeId() {
  var _ref80 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref80$employeeId = _ref80.employeeId,
    employeeId = _ref80$employeeId === void 0 ? '' : _ref80$employeeId;
  return employeeId;
};

/**
 * @function userPayPeriodDataRowToStartDate
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToStartDate = function userPayPeriodDataRowToStartDate() {
  var _ref81 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref81$startDate = _ref81.startDate,
    startDate = _ref81$startDate === void 0 ? '' : _ref81$startDate;
  return startDate;
};

/**
 * @function userPayPeriodDataRowToEndDate
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToEndDate = function userPayPeriodDataRowToEndDate() {
  var _ref82 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref82$endDate = _ref82.endDate,
    endDate = _ref82$endDate === void 0 ? '' : _ref82$endDate;
  return endDate;
};

/**
 * @function userPayPeriodDataRowToPayModelName
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToPayModelName = function userPayPeriodDataRowToPayModelName() {
  var _ref83 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref83$payModelName = _ref83.payModelName,
    payModelName = _ref83$payModelName === void 0 ? '' : _ref83$payModelName;
  return payModelName;
};

/**
 * @function userPayPeriodDataRowToTotalCalls
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToTotalCalls = function userPayPeriodDataRowToTotalCalls() {
  var _ref84 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref84$totalCalls = _ref84.totalCalls,
    totalCalls = _ref84$totalCalls === void 0 ? '' : _ref84$totalCalls;
  return totalCalls;
};

/**
 * @function userPayPeriodDataRowToSales
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToSales = function userPayPeriodDataRowToSales() {
  var _ref85 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref85$sales = _ref85.sales,
    sales = _ref85$sales === void 0 ? '' : _ref85$sales;
  return sales;
};

/**
 * @function userPayPeriodDataRowToTotalPay
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToTotalPay = function userPayPeriodDataRowToTotalPay() {
  var _ref86 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref86$totalPay = _ref86.totalPay,
    totalPay = _ref86$totalPay === void 0 ? '' : _ref86$totalPay;
  return totalPay;
};

/**
 * @function userPayPeriodDataRowToServeMetricName
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToServeMetricName = function userPayPeriodDataRowToServeMetricName() {
  var _ref87 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref87$serveMetricNam = _ref87.serveMetricName,
    serveMetricName = _ref87$serveMetricNam === void 0 ? '' : _ref87$serveMetricNam;
  return serveMetricName;
};

/**
 * @function userPayPeriodDataRowToServeValue
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToServeValue = function userPayPeriodDataRowToServeValue() {
  var _ref88 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref88$serveValue = _ref88.serveValue,
    serveValue = _ref88$serveValue === void 0 ? '' : _ref88$serveValue;
  return serveValue;
};

/**
 * @function userPayPeriodDataRowToServePay
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToServePay = function userPayPeriodDataRowToServePay() {
  var _ref89 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref89$servePay = _ref89.servePay,
    servePay = _ref89$servePay === void 0 ? '' : _ref89$servePay;
  return servePay;
};

/**
 * @function userPayPeriodDataRowToSP100MetricName
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToSP100MetricName = function userPayPeriodDataRowToSP100MetricName() {
  var _ref90 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref90$sp100MetricNam = _ref90.sp100MetricName,
    sp100MetricName = _ref90$sp100MetricNam === void 0 ? '' : _ref90$sp100MetricNam;
  return sp100MetricName;
};

/**
 * @function userPayPeriodDataRowToSP100Value
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToSP100Value = function userPayPeriodDataRowToSP100Value() {
  var _ref91 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref91$sp100Value = _ref91.sp100Value,
    sp100Value = _ref91$sp100Value === void 0 ? '' : _ref91$sp100Value;
  return sp100Value;
};

/**
 * @function userPayPeriodDataRowToSP100Pay
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToSP100Pay = function userPayPeriodDataRowToSP100Pay() {
  var _ref92 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref92$sp100Pay = _ref92.sp100Pay,
    sp100Pay = _ref92$sp100Pay === void 0 ? '' : _ref92$sp100Pay;
  return sp100Pay;
};

/**
 * @function userPayPeriodDataRowToHeroValue
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToHeroValue = function userPayPeriodDataRowToHeroValue() {
  var _ref93 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref93$heroValue = _ref93.heroValue,
    heroValue = _ref93$heroValue === void 0 ? '' : _ref93$heroValue;
  return heroValue;
};

/**
 * @function userPayPeriodDataRowToHeroPay
 * UserPayPeriodData -> String
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {String}
 */
var userPayPeriodDataRowToHeroPay = function userPayPeriodDataRowToHeroPay() {
  var _ref94 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref94$heroPay = _ref94.heroPay,
    heroPay = _ref94$heroPay === void 0 ? '' : _ref94$heroPay;
  return heroPay;
};

/**
 * @function userPayPeriodDataRowToPayMetricDetails
 * UserPayPeriodData -> [PayMetricDetail]
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {PayMetricDetail[]}
 */
var userPayPeriodDataRowToPayMetricDetails = function userPayPeriodDataRowToPayMetricDetails() {
  var _ref95 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref95$payMetricDetai = _ref95.payMetricDetails,
    payMetricDetails = _ref95$payMetricDetai === void 0 ? [] : _ref95$payMetricDetai;
  return payMetricDetails;
};

/**
 * @function userPayPeriodDataRowToPayRuleDetails
 * UserPayPeriodData -> [PayRuleDetail]
 * @param {UserPayPeriodDataRow} userPayPeriodDataRow
 * @returns {PayRuleDetail[]}
 */
var userPayPeriodDataRowToPayRuleDetails = function userPayPeriodDataRowToPayRuleDetails() {
  var _ref96 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodDataRow(),
    _ref96$payRuleDetails = _ref96.payRuleDetails,
    payRuleDetails = _ref96$payRuleDetails === void 0 ? [] : _ref96$payRuleDetails;
  return payRuleDetails;
};

/**
 * @function payMetricDetailToMetricName
 * PayMetricDetail -> String
 * @param {PayMetricDetail} payMetricDetail
 * @returns {String}
 */
var payMetricDetailToMetricName = function payMetricDetailToMetricName() {
  var _ref97 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayMetricDetail(),
    _ref97$metricName = _ref97.metricName,
    metricName = _ref97$metricName === void 0 ? '' : _ref97$metricName;
  return metricName;
};

/**
 * @function payMetricDetailToMetricValue
 * PayMetricDetail -> String
 * @param {PayMetricDetail} payMetricDetail
 * @returns {String}
 */
var payMetricDetailToMetricValue = function payMetricDetailToMetricValue() {
  var _ref98 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayMetricDetail(),
    _ref98$metricValue = _ref98.metricValue,
    metricValue = _ref98$metricValue === void 0 ? '' : _ref98$metricValue;
  return metricValue;
};

/**
 * @function payMetricDetailToStartDate
 * PayMetricDetail -> String
 * @param {PayMetricDetail} payMetricDetail
 * @returns {String}
 */
var payMetricDetailToStartDate = function payMetricDetailToStartDate() {
  var _ref99 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayMetricDetail(),
    _ref99$startDate = _ref99.startDate,
    startDate = _ref99$startDate === void 0 ? '' : _ref99$startDate;
  return startDate;
};

/**
 * @function payMetricDetailToEndDate
 * PayMetricDetail -> String
 * @param {PayMetricDetail} payMetricDetail
 * @returns {String}
 */
var payMetricDetailToEndDate = function payMetricDetailToEndDate() {
  var _ref100 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayMetricDetail(),
    _ref100$endDate = _ref100.endDate,
    endDate = _ref100$endDate === void 0 ? '' : _ref100$endDate;
  return endDate;
};

/**
 * @function payRuleDetailToPayRuleName
 * PayRuleDetail -> String
 * @param {PayRuleDetail} payRuleDetail
 * @returns {String}
 */
var payRuleDetailToPayRuleName = function payRuleDetailToPayRuleName() {
  var _ref101 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleDetail(),
    _ref101$payRuleName = _ref101.payRuleName,
    payRuleName = _ref101$payRuleName === void 0 ? '' : _ref101$payRuleName;
  return payRuleName;
};

/**
 * @function payRuleDetailToConditionFormula
 * PayRuleDetail -> String
 * @param {PayRuleDetail} payRuleDetail
 * @returns {String}
 */
var payRuleDetailToConditionFormula = function payRuleDetailToConditionFormula() {
  var _ref102 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleDetail(),
    _ref102$conditionForm = _ref102.conditionFormula,
    conditionFormula = _ref102$conditionForm === void 0 ? '' : _ref102$conditionForm;
  return conditionFormula;
};

/**
 * @function payRuleDetailToPayFormula
 * PayRuleDetail -> String
 * @param {PayRuleDetail} payRuleDetail
 * @returns {String}
 */
var payRuleDetailToPayFormula = function payRuleDetailToPayFormula() {
  var _ref103 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleDetail(),
    _ref103$payFormula = _ref103.payFormula,
    payFormula = _ref103$payFormula === void 0 ? '' : _ref103$payFormula;
  return payFormula;
};

/**
 * @function payPeriodToStartDate
 * PayPeriod -> String
 * @param {PayPeriod} payPeriod
 * @returns {String}
 */
var payPeriodToStartDate = function payPeriodToStartDate() {
  var _ref104 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriod(),
    _ref104$startDate = _ref104.startDate,
    startDate = _ref104$startDate === void 0 ? '' : _ref104$startDate;
  return startDate;
};

/**
 * @function payPeriodToEndDate
 * PayPeriod -> String
 * @param {PayPeriod} payPeriod
 * @returns {String}
 */
var payPeriodToEndDate = function payPeriodToEndDate() {
  var _ref105 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayPeriod(),
    _ref105$endDate = _ref105.endDate,
    endDate = _ref105$endDate === void 0 ? '' : _ref105$endDate;
  return endDate;
};

/* eslint-disable no-unused-vars */

/**
 * Get name from UserPayModelBuilder
 *
 * userPayModelBuilderToName :: UserPayModelBuilder -> String
 * @function userPayModelBuilderToName
 * @param {UserPayModelBuilder} userPayModelBuilder
 * @returns {String}
 */
var userPayModelBuilderToName = function userPayModelBuilderToName() {
  var _ref106 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModelBuilder(),
    name = _ref106.name;
  return name;
};

/**
 * Get interval from UserPayModelBuilder
 *
 * userPayModelBuilderToInterval :: UserPayModelBuilder -> String
 * @function userPayModelBuilderToInterval
 * @param {UserPayModelBuilder} userPayModelBuilder
 * @returns {String}
 */
var userPayModelBuilderToInterval = function userPayModelBuilderToInterval() {
  var _ref107 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModelBuilder(),
    interval = _ref107.interval;
  return interval;
};

/**
 * Get employeeIds from UserPayModelBuilder
 *
 * userPayModelBuilderToEmployeeIds :: UserPayModelBuilder -> [String]
 * @function userPayModelBuilderToEmployeeIds
 * @param {UserPayModelBuilder} userPayModelBuilder
 * @returns {String[]}
 */
var userPayModelBuilderToEmployeeIds = function userPayModelBuilderToEmployeeIds() {
  var _ref108 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModelBuilder(),
    employeeIds = _ref108.employeeIds;
  return employeeIds;
};

/**
 * Get name from PayRuleRow
 *
 * payRuleRowToName :: PayRuleRow -> String
 * @function payRuleRowToName
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToName = function payRuleRowToName() {
  var _ref109 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    name = _ref109.name;
  return name;
};

/**
 * Get date from PayRuleRow
 *
 * payRuleRowToDate :: PayRuleRow -> String
 * @function payRuleRowToDate
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToDate = function payRuleRowToDate() {
  var _ref110 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    date = _ref110.date;
  return date;
};

/**
 * Get conditionName from PayRuleRow
 *
 * payRuleRowToConditionName :: PayRuleRow -> String
 * @function payRuleRowToConditionName
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToConditionName = function payRuleRowToConditionName() {
  var _ref111 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    conditionName = _ref111.conditionName;
  return conditionName;
};

/**
 * Get conditionTarget from PayRuleRow
 *
 * payRuleRowToConditionTarget :: PayRuleRow -> String
 * @function payRuleRowToConditionTarget
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToConditionTarget = function payRuleRowToConditionTarget() {
  var _ref112 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    conditionTarget = _ref112.conditionTarget;
  return conditionTarget;
};

/**
 * Get conditionOperation from PayRuleRow
 *
 * payRuleRowToConditionOperation :: PayRuleRow -> String
 * @function payRuleRowToConditionOperation
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToConditionOperation = function payRuleRowToConditionOperation() {
  var _ref113 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    conditionOperation = _ref113.conditionOperation;
  return conditionOperation;
};

/**
 * Get conditionValue from PayRuleRow
 *
 * payRuleRowToConditionValue :: PayRuleRow -> String
 * @function payRuleRowToConditionValue
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToConditionValue = function payRuleRowToConditionValue() {
  var _ref114 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    conditionValue = _ref114.conditionValue;
  return conditionValue;
};

/**
 * Get adjustmentName from PayRuleRow
 *
 * payRuleRowToAdjustmentName :: PayRuleRow -> String
 * @function payRuleRowToAdjustmentName
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToAdjustmentName = function payRuleRowToAdjustmentName() {
  var _ref115 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    adjustmentName = _ref115.adjustmentName;
  return adjustmentName;
};

/**
 * Get adjustmentTarget from PayRuleRow
 *
 * payRuleRowToAdjustmentTarget :: PayRuleRow -> String
 * @function payRuleRowToAdjustmentTarget
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToAdjustmentTarget = function payRuleRowToAdjustmentTarget() {
  var _ref116 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    adjustmentTarget = _ref116.adjustmentTarget;
  return adjustmentTarget;
};

/**
 * Get adjustmentOperation from PayRuleRow
 *
 * payRuleRowToAdjustmentOperation :: PayRuleRow -> String
 * @function payRuleRowToAdjustmentOperation
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToAdjustmentOperation = function payRuleRowToAdjustmentOperation() {
  var _ref117 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    adjustmentOperation = _ref117.adjustmentOperation;
  return adjustmentOperation;
};

/**
 * Get adjustmentValue from PayRuleRow
 *
 * payRuleRowToAdjustmentValue :: PayRuleRow -> String
 * @function payRuleRowToAdjustmentValue
 * @param {PayRuleRow} payRuleRow
 * @returns {String}
 */
var payRuleRowToAdjustmentValue = function payRuleRowToAdjustmentValue() {
  var _ref118 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRuleRow(),
    adjustmentValue = _ref118.adjustmentValue;
  return adjustmentValue;
};

/**
 * Get name from PayRule
 *
 * payRuleToName :: PayRule -> String
 * @function payRuleToName
 * @param {PayRule} payRule
 * @returns {String}
 */
var payRuleToName = function payRuleToName() {
  var _ref119 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRule(),
    name = _ref119.name;
  return name;
};

/**
 * Get conditions from PayRule
 *
 * payRuleToConditions :: PayRule -> [Condition]
 * @function payRuleToConditions
 * @param {PayRule} payRule
 * @returns {Operation[]}
 */
var payRuleToConditions = function payRuleToConditions() {
  var _ref120 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRule(),
    conditions = _ref120.conditions;
  return conditions;
};

/**
 * Get adjustments from PayRule
 *
 * payRuleToAdjustments :: PayRule -> [Adjustment]
 * @function payRuleToAdjustments
 * @param {PayRule} payRule
 * @returns {Operation[]}
 */
var payRuleToAdjustments = function payRuleToAdjustments() {
  var _ref121 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRule(),
    adjustments = _ref121.adjustments;
  return adjustments;
};

/**
 * Get startDate from PayRule
 *
 * payRuleToStartDate :: PayRule -> Date
 * @function payRuleToStartDate
 * @param {PayRule} payRule
 * @returns {Date}
 */
var payRuleToStartDate = function payRuleToStartDate() {
  var _ref122 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRule(),
    startDate = _ref122.startDate;
  return startDate;
};

/**
 * Get name from UserPayModel
 *
 * userPayModelToName :: UserPayModel -> String
 * @function userPayModelToName
 * @param {UserPayModel} userPayModel
 * @returns {String}
 */
var userPayModelToName = function userPayModelToName() {
  var _ref123 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModel(),
    name = _ref123.name;
  return name;
};

/**
 * Get users from UserPayModel
 *
 * userPayModelToUsers :: UserPayModel -> [String]
 * @function userPayModelToUsers
 * @param {UserPayModel} userPayModel
 * @returns {String[]}
 */
var userPayModelToUsers = function userPayModelToUsers() {
  var _ref124 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModel(),
    users = _ref124.users;
  return users;
};

/**
 * Get dateRange from UserPayModel
 *
 * userPayModelToDateRange :: UserPayModel -> DateRange
 * @function userPayModelToDateRange
 * @param {UserPayModel} userPayModel
 * @returns {DateRange}
 */
var userPayModelToDateRange = function userPayModelToDateRange() {
  var _ref125 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModel(),
    dateRange = _ref125.dateRange;
  return dateRange;
};

/**
 * Get payRules from UserPayModel
 *
 * userPayModelToPayRules :: UserPayModel -> [PayRule]
 * @function userPayModelToPayRules
 * @param {UserPayModel} userPayModel
 * @returns {PayRule[]}
 */
var userPayModelToPayRules = function userPayModelToPayRules() {
  var _ref126 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayModel(),
    payRules = _ref126.payRules;
  return payRules;
};

/**
 * Get name from PayCalculation
 *
 * payCalculationToName :: PayCalculation -> String
 * @function payCalculationToName
 * @param {PayCalculation} payCalculation
 * @returns {String}
 */
var payCalculationToName = function payCalculationToName() {
  var _ref127 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayCalculation(),
    name = _ref127.name;
  return name;
};

/**
 * Get employeeId from PayCalculation
 *
 * payCalculationToEmployeeId :: PayCalculation -> String
 * @function payCalculationToEmployeeId
 * @param {PayCalculation} payCalculation
 * @returns {String}
 */
var payCalculationToEmployeeId = function payCalculationToEmployeeId() {
  var _ref128 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayCalculation(),
    employeeId = _ref128.employeeId;
  return employeeId;
};

/**
 * Get dateRange from PayCalculation
 *
 * payCalculationToDateRange :: PayCalculation -> DateRange
 * @function payCalculationToDateRange
 * @param {PayCalculation} payCalculation
 * @returns {DateRange}
 */
var payCalculationToDateRange = function payCalculationToDateRange() {
  var _ref129 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayCalculation(),
    dateRange = _ref129.dateRange;
  return dateRange;
};

/**
 * Get metrics from PayCalculation
 *
 * payCalculationToMetrics :: PayCalculation -> [PayMetric]
 * @function payCalculationToMetrics
 * @param {PayCalculation} payCalculation
 * @returns {PayMetric[]}
 */
var payCalculationToMetrics = function payCalculationToMetrics() {
  var _ref130 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayCalculation(),
    metrics = _ref130.metrics;
  return metrics;
};

/**
 * Get payRules from PayCalculation
 *
 * payCalculationToPayRules :: PayCalculation -> [PayRule]
 * @function payCalculationToPayRules
 * @param {PayCalculation} payCalculation
 * @returns {PayRule[]}
 */
var payCalculationToPayRules = function payCalculationToPayRules() {
  var _ref131 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayCalculation(),
    payRules = _ref131.payRules;
  return payRules;
};

/**
 * Get conditions from PayRecord
 *
 * payRecordToConditions :: PayRecord -> [Condition]
 * @function payRecordToConditions
 * @param {PayRecord} payRecord
 * @returns {Operation[]}
 */
var payRecordToConditions = function payRecordToConditions() {
  var _ref132 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRecord(),
    conditions = _ref132.conditions;
  return conditions;
};

/**
 * Get adjustments from PayRecord
 *
 * payRecordToAdjustments :: PayRecord -> [Adjustment]
 * @function payRecordToAdjustments
 * @param {PayRecord} payRecord
 * @returns {Operation[]}
 */
var payRecordToAdjustments = function payRecordToAdjustments() {
  var _ref133 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRecord(),
    adjustments = _ref133.adjustments;
  return adjustments;
};

/**
 * Get earning from PayRecord
 *
 * payRecordToEarning :: PayRecord -> String
 * @function payRecordToEarning
 * @param {PayRecord} payRecord
 * @returns {String}
 */
var payRecordToEarning = function payRecordToEarning() {
  var _ref134 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRecord(),
    earning = _ref134.earning;
  return earning;
};

/**
 * Get payRate from PayRecord
 *
 * payRecordToPayRate :: PayRecord -> String
 * @function payRecordToPayRate
 * @param {PayRecord} payRecord
 * @returns {String}
 */
var payRecordToPayRate = function payRecordToPayRate() {
  var _ref135 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayRecord(),
    payrate = _ref135.payrate;
  return payrate;
};

/**
 * Get payMetrics from UserPayPeriodData
 *
 * userPayPeriodDataToPayMetrics :: UserPayPeriodData -> [PayMetric]
 * @function userPayPeriodDataToPayMetrics
 * @param {UserPayPeriodData} userPayPeriodData
 * @returns {PayMetric[]}
 */
var userPayPeriodDataToPayMetrics = function userPayPeriodDataToPayMetrics() {
  var _ref136 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodData(),
    payMetrics = _ref136.payMetrics;
  return payMetrics;
};

/**
 * Get payRecords from UserPayPeriodData
 *
 * userPayPeriodDataToPayRecords :: UserPayPeriodData -> [PayRecord]
 * @function userPayPeriodDataToPayRecords
 * @param {UserPayPeriodData} userPayPeriodData
 * @returns {PayRecord[]}
 */
var userPayPeriodDataToPayRecords = function userPayPeriodDataToPayRecords() {
  var _ref137 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodData(),
    payRecords = _ref137.payRecords;
  return payRecords;
};

/**
 * Get payRules from UserPayPeriodData
 *
 * userPayPeriodDataToPayRules :: UserPayPeriodData -> [PayRule]
 * @function userPayPeriodDataToPayRules
 * @param {UserPayPeriodData} userPayPeriodData
 * @returns {PayRule[]}
 */
var userPayPeriodDataToPayRules = function userPayPeriodDataToPayRules() {
  var _ref138 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodData(),
    payRules = _ref138.payRules;
  return payRules;
};

/**
 * Get dateRange from UserPayPeriodData
 *
 * userPayPeriodDataToDateRange :: UserPayPeriodData -> DateRange
 * @function userPayPeriodDataToDateRange
 * @param {UserPayPeriodData} userPayPeriodData
 * @returns {DateRange}
 */
var userPayPeriodDataToDateRange = function userPayPeriodDataToDateRange() {
  var _ref139 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new UserPayPeriodData(),
    dateRange = _ref139.dateRange;
  return dateRange;
};

/**
 * Get payCode from PayDescription
 * @function payDescriptionToPayCode
 * PayDescription -> String
 * @param {PayDescription} payDescription
 * @returns {String}
 */
var payDescriptionToPayCode = function payDescriptionToPayCode() {
  var _ref140 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayDescription(),
    payCode = _ref140.payCode;
  return payCode;
};

/**
 * Get employeeId from PayDescription
 * @function payDescriptionToEmployeeId
 * PayDescription -> String
 * @param {PayDescription} payDescription
 * @returns {String}
 */
var payDescriptionToEmployeeId = function payDescriptionToEmployeeId() {
  var _ref141 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayDescription(),
    employeeId = _ref141.employeeId;
  return employeeId;
};

/**
 * Get dateRange from PayDescription
 * @function payDescriptionToDateRange
 * PayDescription -> DateRange
 * @param {PayDescription} payDescription
 * @returns {DateRange}
 */
var payDescriptionToDateRange = function payDescriptionToDateRange() {
  var _ref142 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayDescription(),
    dateRange = _ref142.dateRange;
  return dateRange;
};

/**
 * Get metric from PayMetric
 * @function payMetricToMetric
 * PayMetric -> Metric
 * @param {PayMetric} payMetric
 * @returns {Metric}
 */
var payMetricToMetric = function payMetricToMetric() {
  var _ref143 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayMetric(),
    metric = _ref143.metric;
  return metric;
};

/**
 * Get payDescription from PayMetric
 * @function payMetricToPayDescription
 * PayMetric -> PayDescription
 * @param {PayMetric} payMetric
 * @returns {PayDescription}
 */
var payMetricToPayDescription = function payMetricToPayDescription() {
  var _ref144 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PayMetric(),
    payDescription = _ref144.payDescription;
  return payDescription;
};

/* eslint-disable no-unused-vars */

/** Class representing a PerformanceDescription */
var PerformanceDescription = /*#__PURE__*/_createClass(
/**
 * Create a PerformanceDescription
 *
 * A PerformanceDescription is a set of classifying information used to describe a metric.
 * @property {string} client
 * @property {string} subClient
 * @property {string} businessUnit
 * @property {string} channel
 * @property {string} location
 * @property {string} jobCode
 * @property {string} dataMartSource
 * @property {string} employeeId
 * @property {DateRange} dateRange
 * @property {string} name
 */
function PerformanceDescription() {
  var client = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var subClient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var businessUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var channel = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var location = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var jobCode = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var dataMartSource = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var employeeId = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var dateRange = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : new DateRange();
  var name = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  _classCallCheck(this, PerformanceDescription);
  /** @type {string} */
  this.client = client;
  /** @type {string} */
  this.subClient = subClient;
  /** @type {string} */
  this.businessUnit = businessUnit;
  /** @type {string} */
  this.channel = channel;
  /** @type {string} */
  this.location = location;
  /** @type {string} */
  this.jobCode = jobCode;
  /** @type {string} */
  this.dataMartSource = dataMartSource;
  /** @type {string} */
  this.employeeId = employeeId;
  /** @type {DateRange} */
  this.dateRange = dateRange;
  /** @type {string} */
  this.name = name;
});
/** Class representing a PerformanceMetric */
var PerformanceMetric = /*#__PURE__*/_createClass(
/**
 * Create a PerformanceMetric
 * @property {PerformanceDescription} performanceDescription
 * @property {Metric} metric
 */
function PerformanceMetric() {
  var performanceDescription = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription();
  var metric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Metric();
  _classCallCheck(this, PerformanceMetric);
  /** @type {PerformanceDescription} */
  this.performanceDescription = performanceDescription;
  /** @type {Metric} */
  this.metric = metric;
});
/** Class representing a MetricObjectBase */
var MetricObjectBase = /*#__PURE__*/_createClass(
/**
 * Create a MetricObjectBase
 *
 * A MetricObjectBase is the source metric unit that Helix consumes.
 * @property {string} metric_name
 * @property {string} value
 */
function MetricObjectBase() {
  var metric_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  _classCallCheck(this, MetricObjectBase);
  /** @type {string} */
  this.metric_name = metric_name;
  /** @type {Number} */
  this.value = value;
});
/** Class representing a MetricObject */
var MetricObject = /*#__PURE__*/_createClass(
/**
 * Create a MetricObject
 *
 * A MetricObject is the source metric unit that Helix consumes.
 * @property {string} client
 * @property {string} subclient
 * @property {string} emplid
 * @property {MetricObjectBase[]} metric
 * @property {string} JobCode
 * @property {string} channel
 * @property {string} location
 * @property {string} dm_source
 * @property {string} emp_level
 * @property {string} metric_date
 * @property {string} business_unit
 * @property {string} aggregate_level
 */
function MetricObject() {
  var client = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var subclient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var emplid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var metric = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var JobCode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var channel = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
  var location = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var dm_source = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
  var emp_level = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  var metric_date = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var business_unit = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';
  var aggregate_level = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : '';
  _classCallCheck(this, MetricObject);
  /** @type {string} */
  this.client = client;
  /** @type {string} */
  this.subclient = subclient;
  /** @type {string} */
  this.emplid = emplid;
  /** @type {MetricObjectBase[]} */
  this.metric = metric;
  /** @type {string} */
  this.JobCode = JobCode;
  /** @type {string} */
  this.channel = channel;
  /** @type {string} */
  this.location = location;
  /** @type {string} */
  this.dm_source = dm_source;
  /** @type {string} */
  this.emp_level = emp_level;
  /** @type {string} */
  this.metric_date = metric_date;
  /** @type {string} */
  this.business_unit = business_unit;
  /** @type {string} */
  this.aggregate_level = aggregate_level;
});
/** Class representing a MetricRowObject */
var MetricRowObject = /*#__PURE__*/_createClass(
/**
 * Create a MetricRowObject
 * @property {string} emplid
 * @property {string} clndr_dt
 * @property {string} agg_level
 * @property {string} emp_level
 * @property {MetricObject[]} metric_json
 */
function MetricRowObject() {
  var emplid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var clndr_dt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var agg_level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var emp_level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var metric_json = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  _classCallCheck(this, MetricRowObject);
  /** @type {string} */
  this.emplid = emplid;
  /** @type {string} */
  this.clndr_dt = clndr_dt;
  /** @type {string} */
  this.agg_level = agg_level;
  /** @type {string} */
  this.emp_level = emp_level;
  /** @type {MetricObject[]} */
  this.metric_json = metric_json;
});
/** Class representing a MetricQuery */
var MetricQuery = /*#__PURE__*/_createClass(
/**
 * Create a MetricQuery
 * @property {String[]} users
 * @property {DateRange} dateRange
 */
function MetricQuery() {
  var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dateRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new DateRange();
  _classCallCheck(this, MetricQuery);
  /** @type {String[]} */
  this.users = users;
  /** @type {DateRange} */
  this.dateRange = dateRange;
});
/* eslint-disable no-unused-vars */
/**
 * Get metric_name from MetricObjectBase
 *
 * metricObjectBaseToMetricName :: MetricObjectBase -> String
 * @function metricObjectBaseToMetricName
 * @param {MetricObjectBase} metricObjectBase
 * @returns {String}
 */
var metricObjectBaseToMetricName = function metricObjectBaseToMetricName() {
  var _ref145 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObjectBase(),
    metric_name = _ref145.metric_name;
  return metric_name;
};

/**
 * Get value from MetricObjectBase
 *
 * metricObjectBaseToValue :: MetricObjectBase -> Number
 * @function metricObjectBaseToValue
 * @param {MetricObjectBase} metricObjectBase
 * @returns {Number}
 */
var metricObjectBaseToValue = function metricObjectBaseToValue() {
  var _ref146 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObjectBase(),
    value = _ref146.value;
  return value;
};

/**
 * Get client from MetricObject
 *
 * metricObjectToClient :: MetricObject -> String
 * @function metricObjectToClient
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToClient = function metricObjectToClient() {
  var _ref147 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    client = _ref147.client;
  return client;
};

/**
 * Get subclient from MetricObject
 *
 * metricObjectToSubClient :: MetricObject -> String
 * @function metricObjectToSubClient
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToSubClient = function metricObjectToSubClient() {
  var _ref148 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    subclient = _ref148.subclient;
  return subclient;
};

/**
 * Get emplid from MetricObject
 *
 * metricObjectToEmplid :: MetricObject -> String
 * @function metricObjectToEmplid
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToEmplid = function metricObjectToEmplid() {
  var _ref149 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    emplid = _ref149.emplid;
  return emplid;
};

/**
 * Get jobCode from MetricObject
 *
 * metricObjectToJobCode :: MetricObject -> String
 * @function metricObjectToJobCode
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToJobCode = function metricObjectToJobCode() {
  var _ref150 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    JobCode = _ref150.JobCode;
  return JobCode;
};

/**
 * Get metric_date from MetricObject
 *
 * metricObjectToMetricDate :: MetricObject -> String
 * @function metricObjectToMetricDate
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToMetricDate = function metricObjectToMetricDate() {
  var _ref151 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    metric_date = _ref151.metric_date;
  return metric_date;
};

/**
 * Get channel from MetricObject
 *
 * metricObjectToChannel :: MetricObject -> String
 * @function metricObjectToChannel
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToChannel = function metricObjectToChannel() {
  var _ref152 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    channel = _ref152.channel;
  return channel;
};

/**
 * Get metric from MetricObject
 *
 * metricObjectToMetric :: MetricObject -> [MetricObjectBase]
 * @function metricObjectToMetric
 * @param {MetricObject} metricObject
 * @returns {MetricObjectBase[]}
 */
var metricObjectToMetric = function metricObjectToMetric() {
  var _ref153 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    metric = _ref153.metric;
  return metric;
};

/**
 * Get location from MetricObject
 *
 * metricObjectToLocation :: MetricObject -> String
 * @function metricObjectToLocation
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToLocation = function metricObjectToLocation() {
  var _ref154 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    location = _ref154.location;
  return location;
};

/**
 * Get dm_source from MetricObject
 *
 * metricObjectToDmSource :: MetricObject -> String
 * @function metricObjectToDmSource
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToDmSource = function metricObjectToDmSource() {
  var _ref155 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    dm_source = _ref155.dm_source;
  return dm_source;
};

/**
 * Get business_unit from MetricObject
 *
 * metricObjectToBusinessUnit :: MetricObject -> String
 * @function metricObjectToBusinessUnit
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToBusinessUnit = function metricObjectToBusinessUnit() {
  var _ref156 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    business_unit = _ref156.business_unit;
  return business_unit;
};

/**
 * Get aggregate_level from MetricObject
 *
 * metricObjectToAggregateLevel :: MetricObject -> String
 * @function metricObjectToAggregateLevel
 * @param {MetricObject} metricObject
 * @returns {String}
 */
var metricObjectToAggregateLevel = function metricObjectToAggregateLevel() {
  var _ref157 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricObject(),
    aggregate_level = _ref157.aggregate_level;
  return aggregate_level;
};

/**
 * Get emplid from MetricRowObject
 *
 * metricRowObjectToEmplid :: MetrowRowObject -> String
 * @function metricRowObjectToEmplid
 * @param {MetricRowObject} metricRowObject
 * @returns {String}
 */
var metricRowObjectToEmplid = function metricRowObjectToEmplid() {
  var _ref158 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricRowObject(),
    emplid = _ref158.emplid;
  return emplid;
};

/**
 * Get clndr_dt from MetricRowObject
 *
 * metricRowObjectToClndrDt :: MetrowRowObject -> String
 * @function metricRowObjectToClndrDt
 * @param {MetricRowObject} metricRowObject
 * @returns {String}
 */
var metricRowObjectToClndrDt = function metricRowObjectToClndrDt() {
  var _ref159 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricRowObject(),
    clndr_dt = _ref159.clndr_dt;
  return clndr_dt;
};

/**
 * Get agg_level from MetricRowObject
 *
 * metricRowObjectToAggLevel :: MetrowRowObject -> String
 * @function metricRowObjectToAggLevel
 * @param {MetricRowObject} metricRowObject
 * @returns {String}
 */
var metricRowObjectToAggLevel = function metricRowObjectToAggLevel() {
  var _ref160 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricRowObject(),
    agg_level = _ref160.agg_level;
  return agg_level;
};

/**
 * Get emp_level from MetricRowObject
 *
 * metricRowObjectToEmpLevel :: MetrowRowObject -> String
 * @function metricRowObjectToEmpLevel
 * @param {MetricRowObject} metricRowObject
 * @returns {String}
 */
var metricRowObjectToEmpLevel = function metricRowObjectToEmpLevel() {
  var _ref161 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricRowObject(),
    emp_level = _ref161.emp_level;
  return emp_level;
};

/**
 * Get MetricObjects from MetricRowObject
 *
 * metricRowObjectToMetricJson :: MetrowRowObject -> [MetricObject]
 * @function metricRowObjectToMetricJson
 * @param {MetricRowObject} metricRowObject
 * @returns {MetricObject[]}
 */
var metricRowObjectToMetricJson = function metricRowObjectToMetricJson() {
  var _ref162 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricRowObject(),
    metric_json = _ref162.metric_json;
  return metric_json;
};

/**
 * Get name from PerformanceDescription
 *
 * performanceDescriptionToName :: PerformanceDescription -> String
 * @function performanceDescriptionToName
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToName = function performanceDescriptionToName() {
  var _ref163 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    name = _ref163.name;
  return name;
};

/**
 * Get client from PerformanceDescription
 *
 * performanceDescriptionToClient :: PerformanceDescription -> String
 * @function performanceDescriptionToClient
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToClient = function performanceDescriptionToClient() {
  var _ref164 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    client = _ref164.client;
  return client;
};

/**
 * Get subClient from PerformanceDescription
 *
 * performanceDescriptionToSubClient :: PerformanceDescription -> String
 * @function performanceDescriptionToSubClient
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToSubClient = function performanceDescriptionToSubClient() {
  var _ref165 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    subClient = _ref165.subClient;
  return subClient;
};

/**
 * Get businessUnit from PerformanceDescription
 *
 * performanceDescriptionToBusinessUnit :: PerformanceDescription -> String
 * @function performanceDescriptionToBusinessUnit
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToBusinessUnit = function performanceDescriptionToBusinessUnit() {
  var _ref166 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    businessUnit = _ref166.businessUnit;
  return businessUnit;
};

/**
 * Get channel from PerformanceDescription
 *
 * performanceDescriptionToChannel :: PerformanceDescription -> String
 * @function performanceDescriptionToChannel
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToChannel = function performanceDescriptionToChannel() {
  var _ref167 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    channel = _ref167.channel;
  return channel;
};

/**
 * Get location from PerformanceDescription
 *
 * performanceDescriptionToLocation :: PerformanceDescription -> String
 * @function performanceDescriptionToLocation
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToLocation = function performanceDescriptionToLocation() {
  var _ref168 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    location = _ref168.location;
  return location;
};

/**
 * Get jobCode from PerformanceDescription
 *
 * performanceDescriptionToJobCode :: PerformanceDescription -> String
 * @function performanceDescriptionToJobCode
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToJobCode = function performanceDescriptionToJobCode() {
  var _ref169 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    jobCode = _ref169.jobCode;
  return jobCode;
};

/**
 * Get dataMartSource from PerformanceDescription
 *
 * performanceDescriptionToDataMartSource :: PerformanceDescription -> String
 * @function performanceDescriptionToDataMartSource
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToDataMartSource = function performanceDescriptionToDataMartSource() {
  var _ref170 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    dataMartSource = _ref170.dataMartSource;
  return dataMartSource;
};

/**
 * Get employeeId from PerformanceDescription
 *
 * performanceDescriptionToEmployeeId :: PerformanceDescription -> String
 * @function performanceDescriptionToEmployeeId
 * @param {PerformanceDescription} performanceDescription
 * @returns {String}
 */
var performanceDescriptionToEmployeeId = function performanceDescriptionToEmployeeId() {
  var _ref171 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    employeeId = _ref171.employeeId;
  return employeeId;
};

/**
 * Get dateRange from PerformanceDescription
 *
 * performanceDescriptionToDateRange :: PerformanceDescription -> DateRange
 * @function performanceDescriptionToDateRange
 * @param {PerformanceDescription} performanceDescription
 * @returns {DateRange}
 */
var performanceDescriptionToDateRange = function performanceDescriptionToDateRange() {
  var _ref172 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceDescription(),
    dateRange = _ref172.dateRange;
  return dateRange;
};

/**
 * Get performanceDescription from PerformanceMetric
 *
 * performanceMetricToPerformanceDescription :: PerformanceMetric -> PerformanceDescription
 * @function performanceMetricToPerformanceDescription
 * @param {PerformanceMetric} performanceMetric
 * @returns {PerformanceDescription}
 */
var performanceMetricToPerformanceDescription = function performanceMetricToPerformanceDescription() {
  var _ref173 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    performanceDescription = _ref173.performanceDescription;
  return performanceDescription;
};

/**
 * Get metric from PerformanceMetric
 *
 * performanceMetricToMetric :: PerformanceMetric -> Metric
 * @function performanceMetricToMetric
 * @param {PerformanceMetric} performanceMetric
 * @returns {Metric}
 */
var performanceMetricToMetric = function performanceMetricToMetric() {
  var _ref174 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new PerformanceMetric(),
    metric = _ref174.metric;
  return metric;
};

/**
 * Get users from MetricQuery
 *
 * metricQueryToUsers :: MetricQuery -> [String]
 * @function metricQueryToUsers
 * @param {MetricQuery} metricQuery
 * @returns {String[]}
 */
var metricQueryToUsers = function metricQueryToUsers() {
  var _ref175 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricQuery(),
    users = _ref175.users;
  return users;
};

/**
 * Get dateRange from MetricQuery
 *
 * metricQueryToDateRange :: MetricQuery -> DateRange
 * @function metricQueryToDateRange
 * @param {MetricQuery} metricQuery
 * @returns {DateRange}
 */
var metricQueryToDateRange = function metricQueryToDateRange() {
  var _ref176 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new MetricQuery(),
    dateRange = _ref176.dateRange;
  return dateRange;
};
export { DashboardMetric, DashboardPrimer, DateRange, EarningsCategory, EarningsData, ExpertAssociation, ExpertAssociationRow, Metric, MetricCategory, MetricCategoryRow, MetricDefinition, MetricEarningsData, MetricInformation, MetricMetadata, MetricObject, MetricObjectBase, MetricQuery, MetricRowObject, Operation, PayCalculation, PayDescription, PayMetric, PayMetricDetail, PayPeriod, PayPeriodData, PayPeriodInformation, PayRecord, PayRule, PayRuleAndPayMetricDetail, PayRuleDetail, PayRuleRow, PayViewData, PerformanceCategory, PerformanceDescription, PerformanceMetric, TeamMemberPayData, Tier, User, UserDescription, UserMetric, UserPayModel, UserPayModelBuilder, UserPayPeriodData, UserPayPeriodDataRow, UserRow, dashboardMetricToAbsoluteMax, dashboardMetricToAbsoluteMin, dashboardMetricToDashboardMetricWithAscendingTiers, dashboardMetricToMetricName, dashboardMetricToMetricQuantity, dashboardMetricToMetricValue, dashboardMetricToPayTotal, dashboardMetricToTiers, dashboardMetricToUnitType, dashboardPrimerToEmployeeIds, dateRangeToEndDate, dateRangeToStartDate, expertAssociationRowToClient_Name, expertAssociationRowToExpert_Id, expertAssociationRowToJobcode, expertAssociationRowToLocation, expertAssociationToClientName, expertAssociationToExpertId, expertAssociationToJobCode, expertAssociationToLocation, metricCategoryRowToCategory, metricCategoryRowToMetricDataName, metricCategoryRowToMetricDisplayName, metricCategoryToCategoryName, metricCategoryToMetricMetadatas, metricDefinitionToExpression, metricDefinitionToMetricNames, metricDefinitionToName, metricInformationToCategoryName, metricInformationToEarning, metricInformationToMetricDisplayName, metricInformationToMetricMultiplier, metricInformationToMetricTrueName, metricInformationToMetricType, metricInformationToMetricValue, metricInformationToPayRate, metricInformationToPayRules, metricMetadataToMetricDataName, metricMetadataToMetricDisplayName, metricObjectBaseToMetricName, metricObjectBaseToValue, metricObjectToAggregateLevel, metricObjectToBusinessUnit, metricObjectToChannel, metricObjectToClient, metricObjectToDmSource, metricObjectToEmplid, metricObjectToJobCode, metricObjectToLocation, metricObjectToMetric, metricObjectToMetricDate, metricObjectToSubClient, metricQueryToDateRange, metricQueryToUsers, metricRowObjectToAggLevel, metricRowObjectToClndrDt, metricRowObjectToEmpLevel, metricRowObjectToEmplid, metricRowObjectToMetricJson, metricToName, metricToValue, operationToName, operationToOperator, operationToTarget, operationToType, operationToValue, payCalculationToDateRange, payCalculationToEmployeeId, payCalculationToMetrics, payCalculationToName, payCalculationToPayRules, payDescriptionToDateRange, payDescriptionToEmployeeId, payDescriptionToPayCode, payMetricDetailToEndDate, payMetricDetailToMetricName, payMetricDetailToMetricValue, payMetricDetailToStartDate, payMetricToMetric, payMetricToPayDescription, payPeriodDataToEarnings, payPeriodDataToPayPeriod, payPeriodDataToPayPeriodDataWithSortedDashboardMetrics, payPeriodDataToPerformance, payPeriodDataToSource, payPeriodDatasToPayPeriodDatasWithSortedDashboardMetrics, payPeriodInformationToEmployeeId, payPeriodInformationToEmployeeName, payPeriodInformationToMetricInformations, payPeriodInformationToPayMetrics, payPeriodInformationToPayPeriod, payPeriodInformationToPayRules, payPeriodInformationToTotalEarnings, payPeriodInformationToTotalSales, payPeriodInformationToTotalSessions, payPeriodToEndDate, payPeriodToStartDate, payRecordToAdjustments, payRecordToConditions, payRecordToEarning, payRecordToPayRate, payRuleDetailToConditionFormula, payRuleDetailToPayFormula, payRuleDetailToPayRuleName, payRuleRowToAdjustmentName, payRuleRowToAdjustmentOperation, payRuleRowToAdjustmentTarget, payRuleRowToAdjustmentValue, payRuleRowToConditionName, payRuleRowToConditionOperation, payRuleRowToConditionTarget, payRuleRowToConditionValue, payRuleRowToDate, payRuleRowToName, payRuleToAdjustments, payRuleToConditions, payRuleToName, payRuleToStartDate, payViewDataToEmployeeId, payViewDataToEmployeeName, payViewDataToEmployeePayPeriods, payViewDataToPayViewDataWithSortedDashboardMetrics, payViewDataToTeamMemberPayDatas, performanceCategoriesToPerformanceCategoriesWithSortedDashboardMetrics, performanceCategoryToCategoryTotalQuantity, performanceCategoryToCategoryTotalUnitType, performanceCategoryToMetrics, performanceCategoryToName, performanceDescriptionToBusinessUnit, performanceDescriptionToChannel, performanceDescriptionToClient, performanceDescriptionToDataMartSource, performanceDescriptionToDateRange, performanceDescriptionToEmployeeId, performanceDescriptionToJobCode, performanceDescriptionToLocation, performanceDescriptionToName, performanceDescriptionToSubClient, performanceMetricToMetric, performanceMetricToPerformanceDescription, tierToPayAmount, tierToValue, userDescriptionToClient, userDescriptionToEmployeeId, userDescriptionToLocation, userDescriptionToPayProgram, userMetricToEmployeeId, userMetricToMetric, userPayModelBuilderToEmployeeIds, userPayModelBuilderToInterval, userPayModelBuilderToName, userPayModelToDateRange, userPayModelToName, userPayModelToPayRules, userPayModelToUsers, userPayPeriodDataRowToEmployeeId, userPayPeriodDataRowToEndDate, userPayPeriodDataRowToHeroPay, userPayPeriodDataRowToHeroValue, userPayPeriodDataRowToPayMetricDetails, userPayPeriodDataRowToPayModelName, userPayPeriodDataRowToPayRuleDetails, userPayPeriodDataRowToSP100MetricName, userPayPeriodDataRowToSP100Pay, userPayPeriodDataRowToSP100Value, userPayPeriodDataRowToSales, userPayPeriodDataRowToServeMetricName, userPayPeriodDataRowToServePay, userPayPeriodDataRowToServeValue, userPayPeriodDataRowToStartDate, userPayPeriodDataRowToTotalCalls, userPayPeriodDataRowToTotalPay, userPayPeriodDataToDateRange, userPayPeriodDataToPayMetrics, userPayPeriodDataToPayRecords, userPayPeriodDataToPayRules, userRowToHashKey, userRowToUserDescription, userRowToUserMetrics, userToUserDescription, userToUserMetrics };